{
  "recruiting": "Personāla atlase",
  "courses": "Kursi",
  "courses-page": {
    "title": "Kursi",
    "create": "Izveidot kursu",
    "edit": "Rediģēt kursu",
    "empty": "Pagaidām nav kursu",
    "fields": {
      "title": "Nosaukums",
      "description": "Apraksts",
      "documents-count": "Dokumenti"
    },
    "headers": {
      "title": "Nosaukums",
      "description": "Apraksts",
      "documents": "Dokumenti",
      "actions": "Darbības"
    },
    "dialog": {
      "title-label": "Nosaukums",
      "description-label": "Apraksts",
      "documents-label": "Dokumenti",
      "documents-placeholder": "Atlasiet zināšanu bāzes dokumentus",
      "save": "Saglabāt",
      "cancel": "Atcelt"
    },
    "messages": {
      "created": "Kurss izveidots",
      "updated": "Kurss atjaunināts",
      "deleted": "Kurss dzēsts",
      "error": "Kaut kas nogāja greizi"
    },
    "confirm-delete": "Dzēst šo kursu? To nevar atsaukt."
  },
  "ai-study-chat": "AI mācību čats",
  "ai-study-chat-page": {
    "title": "AI mācību čats",
    "new-conversation": "Jauna saruna",
    "empty-sidebar": "Pagaidām nav sarunu",
    "empty-thread": "Izvēlieties kursu vai scenāriju, lai sāktu mācīties",
    "untitled": "Jauns čats",
    "input-placeholder": "Ierakstiet savu jautājumu…",
    "send": "Sūtīt",
    "typing": "Asistents raksta…",
    "sources": "Avoti ({count})",
    "score": "atbilstība",
    "retry": "Mēģināt vēlreiz",
    "failed": "Neizdevās nosūtīt",
    "quota": {
      "remaining": "Atlikušas {count} ziņas",
      "exhausted": "Jūsu AI čata ziņu limits ir izsmelts.",
      "unavailable": "AI čats nav pieejams jūsu plānā."
    },
    "sources-label": "Avoti",
    "copy": "Kopēt",
    "copied": "Nokopēts",
    "search-placeholder": "Meklēt sarunas",
    "search-empty": "Nekas nav atrasts",
    "empty": {
      "heading": "Gatavs palīdzēt tev mācīties",
      "subtitle": "Jautā visu par kursa materiāliem — es atradīšu atbildi zināšanu bāzē un parādīšu avotus."
    },
    "groups": {
      "today": "Šodien",
      "yesterday": "Vakar",
      "earlier": "Agrāk"
    },
    "composer": {
      "context": "Konteksts:",
      "hint": "Atbildes ģenerē MI no jūsu materiāliem · Enter — nosūtīt, Shift+Enter — jauna rinda"
    },
    "suggestions-fallback": [
      {
        "title": "Apkopo materiālus",
        "subtitle": "Galvenās atziņas"
      },
      {
        "title": "Izveido mācību plānu",
        "subtitle": "No kurienes sākt"
      },
      {
        "title": "Pārtestē mani",
        "subtitle": "Ātrā pārbaude"
      },
      {
        "title": "Izskaidro vienkārši",
        "subtitle": "Bez žargona"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Analizē šo sesiju", "subtitle": "Galvenās atziņas" },
      { "title": "Ko es izdarīju labi?", "subtitle": "Manas stiprās puses" },
      { "title": "Kur es kļūdījos un kāpēc?", "subtitle": "Izaugsmes punkti" },
      { "title": "Ko uzlabot nākamajā sesijā?", "subtitle": "Konkrēti soļi" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Kā mainās mani rezultāti?", "subtitle": "Pa sesijām" },
      { "title": "Manas stiprās un vājās prasmes", "subtitle": "No sesiju rezultātiem" },
      { "title": "Uz ko man jākoncentrējas?", "subtitle": "Treniņu prioritāte" },
      { "title": "Salīdzini manas pirmās un jaunākās sesijas", "subtitle": "Kas uzlabojies" }
    ],
    "new-dialog": {
      "title": "Jauna saruna",
      "subtitle": "Izvēlieties avotu, no kura MI atbildēs",
      "search": "Meklēt…",
      "search-empty": "Nekas nav atrasts",
      "source-type": "Avots",
      "source-course": "Kurss",
      "source-scenario": "Scenārijs",
      "source-competency": "Kompetence",
      "pick-course": "Izvēlieties kursu",
      "pick-scenario": "Izvēlieties scenāriju",
      "pick-competency": "Izvēlieties kompetenci",
      "pick-target": "Visas sesijas vai konkrēta sesija",
      "all-games": "Visas sesijas — mans progress",
      "all-games-sub": "Rezultātu tendences šai kompetencei",
      "back": "Atpakaļ",
      "no-games": "Nav pabeigtu sesiju",
      "empty-competencies": "Pagaidām nav pabeigtu sesiju",
      "empty-competencies-hint": "Pabeidziet sesiju pēc scenārija ar kompetenci — šeit parādīsies AI analīze",
      "empty-courses": "Pagaidām nav pieejamu kursu",
      "empty-scenarios": "Pagaidām nav pieejamu scenāriju",
      "tag-game": "Sesija",
      "start": "Sākt",
      "cancel": "Atcelt"
    },
    "stage": {
      "searching": "Meklēju tavos materiālos…",
      "reading": "Lasu avotus…",
      "writing": "Rakstu atbildi…",
      "writing_sources": "Analizēju {count} fragmentus…",
      "summarizing_short": "Kārtoju iepriekšējo kontekstu",
      "searching_short": "Meklēju tavos materiālos",
      "reading_short": "Lasu avotus",
      "writing_short": "Rakstu atbildi",
      "writing_sources_short": "Analizēju {count} fragmentus"
    },
    "errors": {
      "send": "Neizdevās nosūtīt jūsu ziņu. Lūdzu, mēģiniet vēlreiz.",
      "quota": "Ziņu limits sasniegts.",
      "rate_limit": "Pārāk daudz pieprasījumu. Lūdzu, uzgaidiet minūti un mēģiniet vēlreiz.",
      "provider_unsupported": "Zināšanu bāzes čats nav pieejams ar jūsu organizācijas pašreizējo AI pakalpojumu sniedzēju.",
      "generic": "Kaut kas nogāja greizi."
    }
  },
  "base_title": "The Reflection",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Lapa nav atrasta ⚠️",
  "404_description": "Mēs nevarējām atrast lapu, kuru meklējat.",
  "404_home": "Atpakaļ uz sākumu",
  "401_title": "Jūs neesat autorizēts! 🔒",
  "401_description": "Jums nav atļaujas piekļūt šai lapai. Atgriezieties sākumā!",
  "401_home": "Atpakaļ uz sākumu",
  "changes_saved": "Izmaiņas saglabātas",
  "coming_soon": "Drīzumā",
  " ": " ",
  "select_date_and_time": "Izvēlieties datumu un laiku",
  "select_date": "Izvēlieties datumu",
  "chat": "Čats",
  "menu": "Izvēlne",
  "games": "Sesijas",
  "tours": "Tūres",
  "library": "Bibliotēka",
  "library-video": "Video",
  "library-scorm": "Kursi",
  "library-documents": "Dokumenti",
  "scenarios": "Scenāriji",
  "competencies": "Kompetences",
  "competencies-list": "Saraksts",
  "skills": "Prasmes",
  "home": "Sākums",
  "home_player": "Dalībnieks",
  "player": "Dalībnieks",
  "home_expert": "Eksperts",
  "reports-analytics-tours": "Tūres",
  "reports": "Atskaites",
  "ranking": "Reitings",
  "analytics": "Analītika",
  "support": "Atbalsts",
  "users": "Lietotāji",
  "participants": "Dalībnieki",
  "departments": "Departamenti",
  "positions": "Amati",
  "user-custom-fields": "Pielāgotie lauki",
  "administration": "Administrācija",
  "ai-assistants": "Mākslīgā intelekta asistenti",
  "ai-profiles": "Mākslīgā intelekta profili",
  "ai-connectors": "Mākslīgā intelekta savienojumi",
  "Audit logs": "Audita žurnāli",
  "organizations": "Organizācijas",
  "loading": "Ielādējas...",
  "retry": "Mēģināt vēlreiz",
  "previous": "Iepriekšējais",
  "next": "Nākamais",
  "save": "Saglabāt",
  "copy": "Kopēt",
  "copy_failed": "Neizdevās nokopēt automātiski. Iezīmējiet tekstu laukā un nokopējiet to manuāli (Ctrl+C vai ⌘C).",
  "confirm": "Apstiprināt",
  "suggest": "Piedāvāt",
  "generate": "Ģenerēt",
  "cancel": "Atcelt",
  "close": "Aizvērt",
  "search": "Meklēt...",
  "accept": "Pieņemt",
  "propose": "Piedāvāt",
  "decline": "Noraidīt",
  "send_request": "Sūtīt pieprasījumu",
  "assign": "Piešķirt",
  "actions": " ",
  "evaluators": {
    "ai": "Mākslīgais intelekts",
    "expert": "Eksperts",
    "player": "Dalībnieks",
    "manager": "Vadītājs",
    "head": "Vadītājs"
  },
  "statistics": {
    "date_from": "No",
    "date_to": "Līdz",
    "competence": "Kompetence",
    "evaluator": "Novērtētājs",
    "last_games_effectiveness": {
      "effectiveness": "Efektivitāte",
      "title": "Efektivitāte pēc sesijām"
    },
    "skill_trend": {
      "average_score": "Vidējais vērtējums",
      "game": "Sesija",
      "score": "Vērtējums",
      "title": "Vidējais vērtējums pēc kompetencēm"
    },
    "player_competence_radar": {
      "title": "Kompetenču statistika",
      "top": "Top 10",
      "players_in_company": "Dalībnieki uzņēmumā",
      "by_games": "Analītika pēc sesijām",
      "subtitle": "Kopējā statistika par jums un jūsu uzņēmumu",
      "filter": "Filtrs",
      "you": "Jūs",
      "company": "Uzņēmums",
      "average_score": "vidējais vērtējums",
      "skills_counted": "{counted} no {total} prasmēm"
    }
  },
  "participant": {
    "upcoming_games": "Gaidošās sesijas",
    "for_rank_games": "Sesijas vērtēšanai"
  },
  "roles": {
    "player": "Dalībnieks",
    "admin": "Superadministrators (sistēma)",
    "scoped_admin": "Vecākais administrators",
    "observer": "Novērotājs",
    "captain": "Kapteinis",
    "expert": "Eksperts",
    "lead_expert": "Vecākais Eksperts",
    "manager": "Vadītājs",
    "support": "Atbalsts",
    "early_access": "Agrīnā piekļuve",
    "head": "Vadītājs",
    "candidate": "Kandidāts"
  },
  "user-status": {
    "active": "Aktīvs",
    "inactive": "Neaktīvs",
    "pending": "Gaidāms"
  },
  "pagination": {
    "showing": "parāda",
    "to": "līdz",
    "of": "no",
    "entries": "ieraksti"
  },
  "validator": {
    "required": "Šis lauks ir obligāts",
    "library": "Faila izmēram jābūt mazākam par 500 MB",
    "email": "E-pasta laukam jābūt derīgam e-pastam",
    "password": "Laukam jāiekļauj vismaz viena lielā, mazā burta, speciāla rakstzīme un cipars (vismaz 8 simboli)",
    "confirm": "Apstiprinājuma parole nesakrīt",
    "at_least": "Laukam jābūt vismaz",
    "items": "vienības",
    "number": "Šim laukam jābūt veselam skaitlim",
    "is_odd": "Šim laukam jābūt pāra skaitlim",
    "number_between": "Ievadiet skaitli starp",
    "number_and": "un",
    "date_range_required": "Nepieciešams intervāls",
    "invalid_date_range": "Nederīgs intervāls",
    "invalid_date_format": "Nederīgs datuma formāts",
    "start_date_after_end_date": "Sākuma datumam jābūt pirms beigu datuma",
    "max_180_days": "Maksimums 180 dienas"
  },
  "user": {
    "menu": {
      "settings": "Iestatījumi",
      "statistics": "Statistika",
      "logout": "Izrakstīties"
    }
  },
  "theme": {
    "system": "Sistēma",
    "light": "Gaišs",
    "dark": "Tumšs"
  },
  "error": {
    "default": "Atvainojiet, radās kļūda. Mūsu speciālisti jau par to zina un to novērsīs pēc iespējas ātrāk.",
    "unauthorized": "Jūsu sesija ir beigusies.",
    "contact-support": "Atvainojiet, radās kļūda. Lūdzu, sazinieties ar tehnisko atbalstu",
    "forbidden": "Piekļuve liegta"
  },
  "confirmation": {
    "sure": "Vai tiešām vēlaties dzēst ierakstu?",
    "sure_return_to_time_scheduling": "Certusne es te velle ludum ad tempus initii conciliandum revocare?",
    "sure_restore": "Vai tiešām vēlaties atjaunot ierakstu?",
    "sure_mark_failed": "Atzīmēt spēli kā neveiksmīgu un neatgriezeniski dzēst visus vērtējumus un dalībnieku protokolus?",
    "success": "Veiksmīgi!",
    "deleted": "Dzēsts",
    "failed_marked": "Spēle atzīmēta kā neveiksmīga",
    "restored": "Atjaunots",
    "cancel": "Atcelts",
    "yes": "Jā",
    "no": "Nē"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Laipni lūgti atpakaļ",
        "progress": "Jūsu kopējais progress",
        "stats": {
          "minutes": "Minūtes sesijā",
          "effectiveness": "Efektivitāte",
          "completed_games_count": "Pabeigtās sesijas",
          "total_games_count": "Kopējais sesiju skaits"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Uzņēmuma reitings",
          "player": "Dalībnieks",
          "effectiveness": "Efektivitāte"
        }
      }
    },
    "head": {
      "my_stats": "Mana statistika",
      "subordinates": "Mani padotie",
      "subordinate_stats": "Padota statistika",
      "select_subordinate": "Izvēlieties padoto, lai skatītu statistiku",
      "no_subordinates": "Nav piešķirti padotie"
    }
  },
  "chat-page": {
    "last_game": "Pēdējā sesija",
    "chats": "Čati",
    "no-chats": "Čati nav atrasti",
    "contacts": "Kontakti",
    "choose": "Izvēlēties kontaktu",
    "send": "Sūtīt",
    "type": "Ierakstiet savu ziņu...",
    "no-contacts": "Kontakti nav atrasti",
    "search": "Meklēt...",
    "start_conversation": "Sākt sarunu",
    "start_connecting": "Sāciet savienoties ar cilvēkiem, izvēloties kādu no kontaktiem kreisajā pusē"
  },
  "scenarios-page": {
    "title": "Nosaukums",
    "export-docx": "Export .docx",
    "copy_title": "Kopēt scenāriju",
    "generate_ai_title": "AI scenārija ģenerēšana",
    "organization": "Uzņēmums",
    "competence": "Kompetence",
    "actions": " ",
    "add": "Pievienot scenāriju",
    "ai-generate": "AI ģenerēšana",
    "copy": "Kopēt scenāriju",
    "add_popup": "Pievienot scenāriju",
    "delete": "Dzēst scenāriju",
    "edit": "Rediģēt scenāriju",
    "edit_popup": "Rediģēt scenāriju",
    "industries": [
      "FMCG/Mazumtirdzniecība",
      "Farmācija",
      "Bankas un Fintech",
      "Viesnīcas un Tūrisms",
      "IT uzņēmumi/SaaS",
      "Restorānu bizness/HoReCa",
      "E-komercija/Tirgus vietas",
      "Ražošana/Industrija 4.0",
      "Loģistika un T&L",
      "Telekomunikācijas",
      "Izglītība/EdTech",
      "Ķīmijas rūpniecība",
      "Piegādes ķēdes pārvaldības programmatūra",
      "Valsts sektors/Bezpeļņas organizācijas"
    ],
    "case_types": [
      "Vadība un Cilvēku vadīšana",
      "Personāla atlase un novērtēšana",
      "Pārdošana un klientu apkalpošana",
      "Sarunas un ietekme",
      "Konfliktu vadība",
      "Stratēģija un izpilde"
    ],
    "cases": [
      [
        "SMART/OKR mērķu izvirzīšana",
        "Attīstošas atgriezeniskās saites sniegšana (SBI/COIN)",
        "Deleģēšana",
        "GROW koučings",
        "Veiktspējas novērtēšana",
        "Mentorings"
      ],
      [
        "Kompetenču intervija (CBI)",
        "Novērtēšana/Novērtēšanas centrs",
        "Ievadīšanas sesija"
      ],
      [
        "Klasiska produkta/pakalpojuma pārdošana",
        "Iebildumu apstrāde",
        "Papildu/Šķērspārdošana",
        "Sūdzību apstrāde",
        "Daudzkanālu pārdošana"
      ],
      [
        "Iekšējās korporatīvās sarunas par budžetu/resursiem",
        "Klienta/piegādātāja līgums",
        "Krīzes sarunas"
      ],
      [
        "Starppersonu konflikts komandā",
        "Vadītājs-padotais",
        "Vērtību/ētikas konflikts"
      ],
      [
        "Projektu portfeļa prioritizēšana",
        "Izmaiņu vadība",
        "Risku analīze"
      ]
    ],
    "formats": [
      "1-1",
      "Grupas"
    ],
    "labels": {
      "industry": "Nozare",
      "case_type": "Gadījuma tips",
      "case": "Gadījums",
      "format": "Formāts",
      "duration": "Ilgums (minūtes)",
      "game_vs_ai": "Sesija pret MI",
      "level": "Līmenis",
      "competence": "Kompetence",
      "description": "Scenārija apraksts",
      "description_hint": "Pēc izvēles aprakstiet scenāriju, ko vēlaties ģenerēt (maks. 4000 rakstzīmes)"
    },
    "generating_in_progress": "Scenārijs tiek ģenerēts, lūdzu, uzgaidiet..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Tūre",
      "full_name": "Dalībnieks",
      "games_count": "Sesijas",
      "team": "Komanda",
      "export": "Eksportēt",
      "effectiveness": "Efektivitāte"
    }
  },
  "report-filters": {
    "department": "Nodaļa",
    "position": "Amats",
    "employee": "Darbinieks",
    "scenario": "Scenārijs",
    "competence": "Kompetence",
    "period": "Periods",
    "reset": "Atiestatīt",
    "only-period-competence": "Tiek ņemti vērā tikai perioda un kompetences filtri"
  },
  "competencies-page": {
    "title": "Nosaukums",
    "export-docx": "Export .docx",
    "skills": "Prasmes",
    "text": "Teksts",
    "display_order": "Kārtošanas secība",
    "ai-assistant": "MI asistents",
    "language": "Valoda",
    "department": "Nodaļa",
    "actions": " ",
    "add": "Pievienot kompetenci",
    "add_popup": "Pievienot kompetenci",
    "delete": "Dzēst kompetenci",
    "edit": "Rediģēt kompetenci",
    "edit_popup": "Rediģēt kompetenci"
  },
  "faq-page": {
    "title": "Jautājumi",
    "question": "Jautājums",
    "text": "Atbilde",
    "is_shared": "Pieejams visiem uzņēmumiem",
    "actions": " ",
    "visibility": "Redzamība",
    "visible_to_all": "Redzams visiem lietotājiem",
    "visible_to_managers": "Redzams tikai vadītājiem",
    "add": "Pievienot jautājumu",
    "add_popup": "Pievienot jautājumu",
    "delete": "Dzēst jautājumu",
    "edit": "Rediģēt jautājumu",
    "edit_popup": "Rediģēt jautājumu"
  },
  "ai-connectors-page": {
    "title": "Mākslīgā intelekta savienojumi",
    "is_shared": "Pieejams visām organizācijām",
    "actions": " ",
    "add": "Pievienot savienojumu",
    "add_popup": "Pievienot savienojumu",
    "delete": "Dzēst savienojumu",
    "edit": "Rediģēt savienojumu",
    "edit_popup": "Rediģēt savienojumu",
    "label": "Etiķete",
    "provider": "Pakalpojumu sniedzējs",
    "service": "Pakalpojums",
    "organization": "Organizācija",
    "status": "Statuss",
    "region": "Reģions",
    "endpoint": "Galapunkts",
    "secret": "Parole/Atslēga",
    "maxConcurrency": "Maksimālā vienlaicīguma pakāpe",
    "timeoutSec": "Noildze",
    "sortOrder": "Kārtošanas secība",
    "config": "Konfigurācija",
    "modelPrimary": "Primary modelis",
    "modelLight": "Light modelis",
    "modelLightHint": "Ja tukšs, light izsaukumi izmanto primary modeli",
    "folderId": "Folder ID",
    "models": "Modeļi",
    "is_default": "Default",
    "notes": "Piezīmes"
  },
  "skills-page": {
    "title": "Nosaukums",
    "display_order": "Kārtošanas secība",
    "competence": "Kompetence",
    "text": "Rādītāji",
    "actions": " ",
    "add": "Pievienot prasmi",
    "add_popup": "Pievienot prasmi",
    "delete": "Dzēst prasmi",
    "edit": "Rediģēt prasmi",
    "edit_popup": "Rediģēt prasmi"
  },
  "departments-page": {
    "title": "Nosaukums",
    "actions": " ",
    "add": "Pievienot departamentu",
    "add_popup": "Pievienot departamentu",
    "delete": "Dzēst departamentu",
    "edit": "Rediģēt departamentu",
    "edit_popup": "Rediģēt departamentu"
  },
  "tours-page": {
    "title": "Nosaukums",
    "actions": " ",
    "add": "Pievienot tūri",
    "add_popup": "Pievienot tūri",
    "delete": "Dzēst tūri",
    "edit": "Rediģēt tūri",
    "edit_popup": "Rediģēt tūri"
  },
  "library-page": {
    "title": "Nosaukums",
    "text": "Apraksts",
    "video": "Video",
    "courses": "Kursi",
    "video_link_copy": "Kopēt saiti",
    "video_in_process": "Video tiek apstrādāts...",
    "is_public": "Publisks",
    "actions": " ",
    "add": "Pievienot video",
    "add_popup": "Pievienot video",
    "delete": "Dzēst video",
    "edit": "Rediģēt video",
    "edit_popup": "Rediģēt video"
  },
  "library-documents-page": {
    "title": "Nosaukums",
    "actions": " ",
    "add": "Pievienot dokumentu",
    "add_popup": "Pievienot dokumentu",
    "delete": "Dzēst dokumentu",
    "edit": "Rediģēt dokumentu",
    "edit_popup": "Rediģēt dokumentu",
    "file": "Fails"
  },
  "scorm-page": {
    "title": "Nosaukums",
    "actions": " ",
    "add": "Pievienot kursu",
    "loading": "Kurss tiek ielādēts...",
    "add_popup": "Pievienot kursu",
    "delete": "Dzēst kursu",
    "edit": "Rediģēt kursu",
    "edit_popup": "Rediģēt kursu",
    "zip_file": "ZIP fails"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Apraksts",
    "actions": " ",
    "add": "Pievienot MI asistentu",
    "add_popup": "Pievienot MI asistentu",
    "delete": "Dzēst MI asistentu",
    "edit": "Rediģēt MI asistentu",
    "edit_popup": "Rediģēt MI asistentu"
  },
  "ai-prompts-page": {
    "name": "Nosaukums",
    "content": "Saturs",
    "actions": " ",
    "add": "Pievienot MI uzvedni",
    "add_popup": "Pievienot MI uzvedni",
    "delete": "Dzēst MI uzvedni",
    "edit": "Rediģēt MI uzvedni",
    "edit_popup": "Rediģēt MI uzvedni",
    "key": "Slota atslēga",
    "model": "Modelis",
    "updated_at": "Atjaunināts",
    "custom": "Pielāgots",
    "description": "Apraksts",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Spriešanas piepūle",
    "reasoning_effort_default": "Noklusējums",
    "required_placeholders": "Obligātie mainīgie (jābūt saturā)",
    "versions": "Versiju vēsture",
    "no_versions": "Versiju vēl nav",
    "restore": "Atjaunot",
    "restore_confirm": "Atjaunot šo versiju? Tās saturs kļūs par pašreizējo.",
    "restored": "Versija atjaunota",
    "current_version": "Pašreizējā",
    "author": "Autors",
    "error": "Kaut kas nogāja greizi.",
    "tab_system": "Sistēma",
    "tab_custom": "Pielāgots",
    "system_hint": "Sistēmas uzvednes izmanto platformas kods. Tās nevar dzēst, taču to saturu var rediģēt.",
    "custom_hint": "Pielāgotas uzvednes tiek piesaistītas kompetencēm un MI profiliem kā vērtēšanas uzvednes aizstājējs.",
    "model_from_code": "nosaka kods",
    "model_from_code_hint": "Modeli izvēlas kods, kas izmanto uzvedni; tas netiek saglabāts pašā uzvednē.",
    "used_by": "Izmantots",
    "used_by_value": "Kompetences: {competencies}, MI profili: {profiles}",
    "not_used": "Netiek izmantots",
    "delete_blocked_hint": "Nevar dzēst: uzvedne tiek izmantota kā aizstājējs. {usage}",
    "slot_description": {
      "game_eval_negotiation": "PvP sesiju MI vērtējums: sarunas",
      "game_eval_feedback": "PvP sesiju MI vērtējums: atgriezeniskā saite",
      "game_eval_vs_ai": "MI vērtējums sesijām pret MI (ja MI profilam nav aizstāšanas)",
      "protocol_evaluation": "Scenārija protokola aizpildīšana pēc sesijas pret MI transkripcijas",
      "voice_agent": "Sistēmas uzvedne balss aģentam",
      "scenario_generation": "Scenārija ģenerēšana no apraksta",
      "scenario_card_update": "Scenārija kartītes atjaunināšana no AI apraksta",
      "scenario_optimize": "Scenārija AI apraksta optimizēšana",
      "skill_report_analysis": "Prasmju pārskats: analīzes posms",
      "skill_report_recommendations": "Prasmju pārskats: ieteikumu posms"
    }
  },
  "ai-profiles-page": {
    "name": "Nosaukums",
    "settings": "Iestatījumi",
    "temperature": "Fantāzija",
    "demeanor": "Uzvedība",
    "behavior": "Uzvedība, instrukcijas",
    "background": "Biogrāfija",
    "style": "Stils",
    "instructions": "Instrukcijas",
    "supportive_phrases": "Atbalsta frāzes",
    "ai_assistant": "MI asistents",
    "ai_starts_first": "MI sāk pirmais",
    "first_phrase": "Pirmā frāze",
    "closing_phrases": "Noslēguma frāzes",
    "voice": "Balss",
    "expert_mode": "Eksperta režīms",
    "custom_demeanor_hint": "Pašreizējā pielāgotā izturēšanās",
    "is_shared": "Pieejams visiem uzņēmumiem",
    "voice_options": {
      "male": "Vīrišķīgs",
      "female": "Sievišķīgs"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Draudzīgs",
        "description": "Viegli pieejams un patīkams"
      },
      "critical": {
        "title": "Kritisks",
        "description": "Bieži norāda uz trūkumiem un uzlabojumu jomām"
      },
      "empathetic": {
        "title": "Empātisks",
        "description": "Ļoti jutīgs pret citu jūtām un emocijām"
      },
      "enthusiastic": {
        "title": "Entuziastisks",
        "description": "Parāda intensīvu satraukumu un dedzību"
      },
      "analytical": {
        "title": "Analītisks",
        "description": "Koncentrējas uz loģiku un detalizētu problēmu risināšanu"
      },
      "curious": {
        "title": "Ziņkārīgs",
        "description": "Vēlas mācīties un uzdot jautājumus"
      },
      "assertive": {
        "title": "Pašapzinīgs",
        "description": "Pārliecināts un pašpārliecināts"
      },
      "blunt": {
        "title": "Tiešs",
        "description": "Tiešs un konkrēts"
      },
      "skeptical": {
        "title": "Skeptisks",
        "description": "Piesardzīgs pret jauniem risinājumiem un idejām"
      },
      "neutral": {
        "title": "Neitrāls",
        "description": "Līdzsvarots un objektīvs komunikācijas stilā"
      },
      "casual": {
        "title": "Neformāls",
        "description": "Atslābināts un sarunvalodīgs tonī"
      }
    },
    "placeholders": {
      "name": "Piemēram: Sergejs (pieklājīgs un draudzīgs)",
      "demeanor": "Piemēram: Draudzīgs, pieklājīgs un sabiedrisks...",
      "background": "Piemēram: Tika atlaists divreiz...",
      "behavior": "Piemēram: Nepārtrauc, aktīvi klausās...",
      "first_phrase": "Piemēram: Labdien! Kāda ir jūsu noskaņa?",
      "closing_phrases": "Piemēram: Mums gandrīz nav laika, tāpēc ierosinu ātri apkopot mūsu tikšanos."
    },
    "actions": " ",
    "add": "Pievienot MI profilu",
    "add_popup": "Pievienot MI profilu",
    "subtitle": "Kā sarunbiedrs izskatās un skan sesijā",
    "preview": {
      "title": "Priekšskatījums",
      "unnamed": "Bez vārda",
      "voice": "balss {name}",
      "defaultVoice": "noklusējuma balss",
      "defaultPhoto": "Noklusējuma fotoattēls",
      "listen": "Noklausīties balsi",
      "defaultVoiceNotice": "Balss tiks izvēlēta sesijas sākumā — iepriekš to noklausīties nevar",
      "photoPlaceholder": "Šeit parādīsies fotoattēls"
    },
    "delete": "Dzēst MI profilu",
    "edit": "Rediģēt MI profilu",
    "edit_popup": "Rediģēt MI profilu",
    "avatar_hint": "avatara attēls",
    "avatar_save_first": "Lai iespējotu avatara augšupielādi, vispirms saglabājiet profilu",
    "avatar_requirements": "Maks. 1 MB • Ieteicams: 1536×1024 • Malu attiecība: 3:2",
    "max_characters": "Ne vairāk kā {max} rakstzīmes"
  },
  "games-page": {
    "game-with-ai": "Sesija ar MI",
    "organization": "Organizācija",
    "status": "Statuss",
    "failure_reasons": {
      "protocol_not_agreed": "Dalībnieki nevienojās par protokolu",
      "protocol_approval_expired": "Protokola saskaņošanas laiks ir beidzies",
      "annulled": "Sesija tika anulēta",
      "expired": "Sesijas laiks beidzās",
      "assignment_changed": "Kursa piešķīrums mācību sistēmā tika mainīts"
    },
    "restore": "Atjaunot",
    "play": "Spēlēt",
    "meetings_unavailable": "Videosesijas starp dalībniekiem īslaicīgi nav pieejamas. Lūdzu, mēģiniet vēlreiz vēlāk.",
    "import": "Importēt",
    "scenario": "Scenārijs",
    "tour": "Tūre",
    "game_types": {
      "classic": "Klasiskais režīms",
      "vs_ai": "Sesija pret MI",
      "uploaded_recording": "Ieraksts"
    },
    "upload_recording": {
      "file": "Ieraksta fails",
      "file_hint": "Video vai audio, līdz 1 GB",
      "uploaded": "Fails augšupielādēts",
      "file_too_large": "Fails lielāks par 1 GB",
      "upload_error": "Neizdevās augšupielādēt failu",
      "player": "Dalībnieks",
      "rate_both": "Novērtēt abus dalībniekus",
      "second_player": "Otrais dalībnieks",
      "open_session": "Atvērt sesiju"
    },
    "game_targets": {
      "user": "Dalībnieks",
      "position": "Amats",
      "department": "Nodaļa"
    },
    "number": "Numurs",
    "start_up_to": "Sākt līdz",
    "start_time": "Sākuma laiks",
    "teamA": "Komanda A",
    "teamB": "Komanda B",
    "others": "Dalībnieki",
    "actions": " ",
    "edit_results": "Mainīt rezultātus",
    "add": "Pievienot sesiju",
    "add_popup": "Pievienot sesiju",
    "delete": "Dzēst sesiju",
    "edit": "Rediģēt sesiju",
    "edit_popup": "Rediģēt sesiju",
    "time_scheduling": "Sākuma laika plānošana",
    "return_to_time_scheduling": "Atgriezties pie sākuma laika saskaņošanas",
    "preparation": "Sagatavošanās sesijai",
    "view_scenario": "Skatīt scenāriju",
    "protocol": "Protokola apstiprināšana",
    "not_agreed": "Nav saskaņots",
    "expert-accept": "Pieņemt un pāriet uz vērtēšanu",
    "expert-decline": "Noraidīt",
    "hide_ai_results": "Paslēpt AI vērtējumu",
    "show_ai_results": "Rādīt AI vērtējumu",
    "mark_failed": "Atzīmēt kā neveiksmīgu",
    "popup": {
      "start_up_to": "Sākt līdz",
      "target": "Kam piešķirt sesiju?",
      "custom_field_value": "Lauka “{field}” vērtība",
      "target_preview_count": "Izveidojamās sesijas: {count}",
      "target_preview_empty": "Neviens spēlētājs neatbilst šai atlasei — neviena sesija netiks izveidota",
      "target_preview_limit_exceeded": "Tas ir vairāk, nekā var izveidot vienā piešķīrumā (ne vairāk kā {limit}). Samaziniet atlasi, gadījumu skaitu vai kopiju skaitu",
      "copies_per_player": "Katra gadījuma kopijas vienam spēlētājam",
      "position": "Amats",
      "department": "Nodaļa",
      "scenario": "Scenārijs",
      "optional": "Neobligāti, var nenorādīt",
      "protocol_time": "Protokola laiks",
      "protocol_time_hint": "Skaitlis no 1 līdz 1440",
      "preparation_time": "Sagatavošanās laiks",
      "preparation_time_hint": "Minūtēs",
      "game_duration": "Sesijas ilgums",
      "game_duration_hint": "Skaitlis no 1 līdz 60",
      "is_team": "Scenārijs komandām",
      "is_camera_required": "Nepieciešamas dalībnieku kameras",
      "is_self_rated": "Dalībnieki var vērtēt sevi",
      "is_each_other_rated": "Dalībnieki var vērtēt viens otru",
      "is_expert_rated": "Pieejams eksperta vērtējums",
      "is_ai_rated": "Pieejams MI vērtējums",
      "show_results": "Rādīt rezultātus",
      "automatically": "automātiski",
      "manually": "manuāli",
      "is_public_hint": "Jebkurš novērotājs varēs pievienoties",
      "is_public": "Publiska sesija",
      "team_a": "Komanda A",
      "team_b": "Komanda B",
      "player_a": "Dalībnieks A",
      "player_b": "Dalībnieks B",
      "expert": "Eksperts",
      "observers": "Novērotāji",
      "tour": "Tūre",
      "search": "Meklēt...",
      "choose_players": "Izvēlēties dalībniekus",
      "choose_expert": "Izvēlēties ekspertu",
      "choose_observers": "Izvēlēties novērotājus",
      "choose_scenario": "Izvēlēties scenāriju",
      "choose_tour": "Izvēlēties tūri",
      "expert_empty": "Ja nav izvēlēts, kapteinis varēs izvēlēties",
      "captain": "Kapteinis",
      "": "",
      "protocol": {
        "title": "Protokola apstiprināšana",
        "target": "Mērķis",
        "await_approval": "Gaidīt pretinieka apstiprinājumu",
        "await_proposal": "Gaidīt pretinieka piedāvājumu",
        "questions": "Jautājumi jūsu komandai",
        "questions_a": "Jautājumi komandai A",
        "questions_b": "Jautājumi komandai B",
        "not_agreed": "Nevienojās",
        "not_agreed_confirm": "Sesija tiks pabeigta neveiksmīgi un rezultāti netiks ieskaitīti. Šī darbība ir neatgriezeniska.",
        "not_agreed_done": "Sesija beidzās neveiksmīgi."
      },
      "start_time": {
        "title": "Sākuma laiks",
        "must_start_by": "Jāsāk līdz"
      },
      "edit_results": {
        "title": "Mainīt rezultātus"
      },
      "preparation": {
        "title": "Sagatavošanās sesijai",
        "description": "Apraksts",
        "description_team": "Komandas apraksts",
        "notes": "Personīgās piezīmes"
      },
      "import": {
        "download_example": "Lejupielādēt piemēru",
        "title": "Sesiju imports",
        "button": "Sākt importu",
        "label": "Excel fails"
      },
      "create_multi_scenario_games_immediately": "Visas sesijas tiks izveidotas uzreiz",
      "create_multi_scenario_games_sequentially": "Sesijas tiks izveidotas secīgi (pēc katra veiksmīga pabeigšanas)"
    }
  },
  "ai-game": {
    "title": "Sesija pret MI",
    "recording": "Ieraksts",
    "ai": "MI",
    "you": "Jūs",
    "ai_ready": "Gatavs",
    "camera_off": "Kamera ir izslēgta",
    "stop_game": "Apturēt sesiju",
    "start_game": "Sākt sesiju",
    "mic_permission": "Lūdzu, piešķiriet mikrofona atļaujas iestatījumos, lai sāktu sesiju",
    "permissions_granted": "Atļaujas veiksmīgi piešķirtas!",
    "close": "Aizvērt",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Ieslēdziet mikrofonu, lai sāktu sesiju",
    "mic_not_detected": "Skaņa vēl nav konstatēta — mēģiniet runāt vai pārbaudiet mikrofonu",
    "permissions_needed": "Piekļuve mikrofonam ir obligāta. Kamera nav obligāta",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Vai esat pārliecināts? Sesiju nevar apturēt",
      "start_title": "Sesija sākta",
      "start_success": "Sesija ir veiksmīgi sākta",
      "start_cancel_title": "Sesija nav sākta",
      "start_cancel_msg": "Sesijas sākšana tika atcelta",
      "end_question": "Vai esat pārliecināts? Sesija tiks beigta",
      "end_title": "Sesija beigta",
      "end_success": "Sesija ir veiksmīgi beigta",
      "end_cancel_title": "Sesija nav beigta",
      "end_cancel_msg": "Sesijas beigšana tika atcelta"
    },
    "voice": {
      "disconnected": "Atvienots",
      "connecting": "Savienojas...",
      "connected": "Savienots ar serveri",
      "connection_error": "Neizdevās savienoties ar balss aģentu",
      "game_already_finished": "Šī spēle jau ir beigusies",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Pašlaik nav pieejamu telpu. Lūdzu, mēģiniet vēlāk.",
      "preparing_recording": "Sagatavojam ierakstu, atkārtots mēģinājums pēc {seconds}s…",
      "recording_service_overloaded": "Ierakstīšanas serviss ir pārslogots. Lūdzu, mēģiniet vēlreiz pēc dažām minūtēm.",
      "session_quota_exhausted": "Jūsu organizācijas sesiju pakete ir izmantota. Lūdzu, sazinieties ar savu vadītāju.",
      "connection_blocked": "Jūsu tīkls bloķēja AI savienojuma izveidi. Atļaujiet HTTPS (443) uz nepieciešamajiem domēniem un mēģiniet vēlreiz.",
      "connection_blocked_signaling": "Jūsu tīkla ugunsmūris vai starpniekserveris bloķē savienojumu ar balss serveri. Mēģiniet pieslēgties no cita tīkla vai mobilā tīklāja.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "Kameras vai mikrofona piekļuve tika liegta. Dodieties uz Safari iestatījumiem > Tīmekļa vietnes > Kamera/Mikrofons un atļaujiet piekļuvi šai vietnei.",
    "supported": "Pārlūks tiek atbalstīts"
  },
  "positions-page": {
    "title": "Nosaukums",
    "actions": " ",
    "add": "Pievienot amatu",
    "add_popup": "Pievienot amatu",
    "delete": "Dzēst amatu",
    "edit": "Rediģēt amatu",
    "edit_popup": "Rediģēt amatu"
  },
  "user-custom-fields-page": {
    "title": "Nosaukums",
    "type": "Tips",
    "options_count": "Vērtības",
    "actions": " ",
    "add": "Pievienot lauku",
    "add_popup": "Pievienot lauku",
    "delete": "Dzēst lauku",
    "delete_confirm": "Vai dzēst lauku? Lietotājiem saglabātās vērtības vairs netiks rādītas.",
    "edit": "Rediģēt lauku",
    "edit_popup": "Rediģēt lauku",
    "empty": "Pagaidām nav pielāgoto lauku",
    "error": "Neizdevās saglabāt lauku",
    "type_text": "Teksts",
    "type_select": "Saraksts",
    "type_locked_hint": "Pēc lauka izveides tā tipu vairs nevar mainīt",
    "options": "Vērtības",
    "options_hint": "Vērtību secība šeit ir to secība nolaižamajā sarakstā",
    "options_required": "Pievienojiet vismaz vienu vērtību",
    "option_title": "Vērtība",
    "option_add": "Pievienot vērtību",
    "option_delete": "Dzēst vērtību",
    "option_delete_confirm": "Vai dzēst vērtību? Lietotājiem, kuriem tā bija izvēlēta, vērtība tiks notīrīta.",
    "option_move_up": "Pārvietot uz augšu",
    "option_move_down": "Pārvietot uz leju"
  },
  "organizations-page": {
    "name": "Nosaukums",
    "host": "Hosts",
    "duel_limit": "Duelu limits",
    "max_users": "Maks. lietotāji",
    "max_users_hint": "0 = neierobežoti",
    "max_vs_ai_games_per_scenario": "Maks. AI spēles spēlētājam vienā scenārijā",
    "max_vs_ai_games_per_scenario_hint": "Tukšs = bez ierobežojuma. Attiecas uz spēlētāja patstāvīgi izveidotām spēlēm",
    "employee_report_daily_limit": "Darbinieku pārskatu diennakts limits",
    "employee_report_daily_limit_hint": "Tukšs = platformas kopējais limits. Attiecas uz vadītājiem",
    "employee_report_hourly_limit": "Darbinieku pārskatu stundas limits",
    "employee_report_hourly_limit_hint": "Tukšs = platformas kopējais limits. Attiecas uz vadītājiem",
    "registration": "Reģistrācija atvērta",
    "timezone": "Laika josla",
    "locale": "Lokāle",
    "users_count": "Lietotāji",
    "actions": " ",
    "add": "Pievienot organizāciju",
    "add_popup": "Pievienot organizāciju",
    "delete": "Dzēst organizāciju",
    "edit": "Rediģēt organizāciju",
    "edit_popup": "Rediģēt organizāciju",
    "available_languages": "Pieejamās valodas",
    "show_game_numbers_for_player": "Rādīt sesiju numurus dalībniekiem",
    "allow_players_choose_expert": "Atļaut dalībniekiem izvēlēties ekspertu",
    "send_message": "Sūtīt ziņojumu vadītājiem",
    "message": "Ziņojums",
    "send": "Sūtīt",
    "clear_message": "Notīrīt ziņojumu",
    "current_message": "Pašreizējais ziņojums",
    "two_factor_method": "Divfaktoru autentifikācija",
    "two_factor_disabled": "Atspējota",
    "two_factor_email": "E-pasts",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Slēpt AI rezultātus",
    "hide_player_rating": "Slēpt uzņēmuma reitingu no dalībniekiem",
    "show_character_memory_to_player": "Rādīt varoņa atmiņu spēlētājam",
    "show_meeting_recap_to_player": "Rādīt tikšanās kopsavilkumu spēlētājam",
    "create_user_on_external_launch": "Izveidot lietotāju pēc pirmā pieprasījuma no ārējas sistēmas",
    "create_user_on_external_launch_hint": "Ja izslēgts, lietotājam, kuru ārējā sistēma pieprasa pirmo reizi, sesijas vietā tiek atteikts. Katrs šādi izveidotais lietotājs aizņem vietu abonementā.",
    "allow_external_email_linking": "Atļaut sasaistīt ārēju lietotāju pēc e-pasta adreses",
    "allow_external_email_linking_hint": "Ja ieslēgts, ārēja persona tiek sasaistīta ar jau esošu lietotāju, ja ārējā sistēma ziņoja viņa e-pasta adresi no sava servera. Ja izslēgts, šāds pieprasījums tiek noraidīts, un otrs lietotājs ar to pašu adresi netiek izveidots."
  },
  "users-page": {
    "import": "Importēt",
    "user": "Lietotājs",
    "roles": "Lomas",
    "effectiveness": "Efektivitāte",
    "department": "Departaments",
    "position": "Amats",
    "status": "Statuss",
    "actions": " ",
    "add": "Pievienot lietotāju",
    "add_popup": "Jauns lietotājs",
    "last_login_at": "Pēdējā pieteikšanās",
    "delete": "Dzēst",
    "view": "Skatīt",
    "login": "Pieteikties",
    "message": "Ziņojums",
    "activate": "Aktivizēt",
    "deactivate": "Bloķēt",
    "edit_popup": "Rediģēt lietotāju",
    "total_in_org": "Kopā organizācijā",
    "multi_role_note": "Lietotājs ar vairākām lomām tiek ieskaitīts katrā žetonā",
    "filter_role": "Loma",
    "all_roles": "Visas lomas",
    "filter_activity": "Pabeigti scenāriji",
    "activity_played": "Jā",
    "activity_not_played": "Nē",
    "filter_activity_from": "Spēlēts kopš",
    "filter_last_login_from": "Pieteikšanās datums",
    "filter_custom_field": "Pielāgotais lauks",
    "filter_custom_field_value": "Lauka “{field}” vērtība",
    "last_login_never": "Nekad nav pieteicies",
    "last_login_since": "Pieteicies kopš",
    "cases_progress": "Pabeigti gadījumi",
    "cases_progress_value": "{completed} no {assigned}",
    "export": "Eksportēt",
    "popup": {
      "name": "Vārds",
      "last_name": "Uzvārds",
      "patronymic": "Tēvavārds",
      "phone": "Telefons",
      "timezone": "Laika josla",
      "language": "Valoda",
      "country": "Valsts",
      "invalid_phone": "Nepareizs telefona numurs",
      "department": "Departaments",
      "position": "Amats",
      "effectiveness": "Efektivitāte",
      "roles": "Lomas",
      "organizations": "Organizācijas",
      "blocked": "Bloķēts",
      "is_active": "Ir aktīvs",
      "email_verified": "E-pasts ir apstiprināts",
      "email_not_verified": "E-pasts nav apstiprināts",
      "subordinates": "Padotie",
      "search_subordinates": "Meklēt dalībniekus...",
      "import": {
        "download_example": "Lejupielādēt piemēru",
        "title": "Lietotāju imports",
        "button": "Sākt importu",
        "label": "Excel fails",
        "marker_hint": "Jau esošam lietotājam tukša šūna saglabā pašreizējo vērtību, bet domuzīme (-) notīra lauku.",
        "result_title": "Imports sākts",
        "result_created": "Tiks izveidoti: {count}",
        "result_updated": "Tiks atjaunināti: {count}",
        "result_skipped": "Izlaistas rindas: {count}",
        "result_skipped_row": "Rinda {row}, {email}: {reason}",
        "result_truncated": "…un vēl izlaistas rindas: {count}"
      }
    }
  },
  "users-ranking-page": {
    "user": "Lietotājs",
    "roles": "Lomas",
    "effectiveness": "Efektivitāte",
    "average-effectiveness": "Vidēji sesijā",
    "sessions-count": "Sesijas",
    "department": "Nodaļa",
    "position": "Amats",
    "status": "Statuss",
    "export": "Eksportēt",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Pabeigtās sesijas",
    "not_found": "Lietotājs nav atrasts",
    "games_total": "Kopā sesijas",
    "username": "Lietotājvārds",
    "phone": "Telefons",
    "status": "Statuss",
    "language": "Valoda",
    "timezone": "Laika josla",
    "edit": "Rediģēt",
    "department": "Departaments",
    "position": "Amats",
    "activate": "Aktivizēt",
    "block": "Bloķēt",
    "account": {
      "title": "Konts",
      "summary": {
        "title": "Kopsavilkums",
        "games": "Notikušās sesijas",
        "place": "Vieta",
        "effectiveness": "Efektivitāte",
        "time": "Laiks"
      }
    },
    "security": {
      "title": "Drošība",
      "change_password_title": "Mainīt paroli",
      "change_password": "Mainīt paroli",
      "new_password": "Jauna parole",
      "confirm_new_password": "Apstiprināt jauno paroli",
      "password_requirements": "Paroles prasības:",
      "password_requirements_1": "Vismaz 8 rakstzīmes - jo vairāk, jo labāk",
      "password_requirements_2": "Vismaz viena mazā burta rakstzīme",
      "password_requirements_3": "Vismaz viens cipars, simbols vai atstarpe"
    },
    "statistics": {
      "title": "Statistika"
    }
  },
  "game": {
    "character_memory": {
      "title": "Ko varonis atceras",
      "subtitle": "Iepriekšējo tikšanos atmiņa, ar kuru varonis ienāk šajā spēlē",
      "preview_subtitle": "Atmiņa vēl nav fiksēta — varonis to saņems spēles sākuma brīdī",
      "unavailable": "Iepriekšējā tikšanās varonim nav pieejama: viņš sāks sarunu, to neatceroties.",
      "agreements": "Vienošanās",
      "player_commitments": "Spēlētāja solījumi",
      "character_commitments": "Varoņa solījumi",
      "open_issues": "Atklātie jautājumi",
      "facts": "Minētie fakti",
      "attitude": "Attieksme pret spēlētāju",
      "evaluation_passed": "Šīs tikšanās vērtējuma rezultāti ir nodoti varonim",
      "evaluation_not_ready": "Šīs tikšanās vērtējums vēl nav gatavs — varonis to saņems, tiklīdz tas būs aprēķināts.",
      "evaluation_hidden": "Vērtējuma tekstus slēpj organizācijas iestatījumi.",
      "overall_effectiveness": "Kopējā efektivitāte",
      "outcome": {
        "deal": "Darījums",
        "partial": "Daļējs",
        "no_deal": "Bez darījuma",
        "unclear": "Neskaidrs"
      }
    },
    "meeting_recap": {
      "title": "Tikšanās kopsavilkums",
      "outcome": "Tikšanās rezultāts",
      "agreements": "Vienošanās",
      "player_commitments": "Spēlētāja solījumi",
      "character_commitments": "Varoņa solījumi",
      "open_issues": "Atklātie jautājumi",
      "facts": "Minētie fakti",
      "pending": "Tikšanās kopsavilkums vēl tiek sagatavots. Lūdzu, mēģiniet vēlāk.",
      "unavailable": "Šīs tikšanās kopsavilkumu neizdevās sagatavot.",
      "none": "Šai spēlei kopsavilkuma nav."
    },
    "title": "Sesija",
    "team": "Komanda",
    "expert": "Eksperts",
    "points": "punkti",
    "your_result": "Jūsu rezultāts",
    "joined_at": "Pievienojās:",
    "ended_at": "Pabeigšanas datums",
    "min": "min.",
    "duration": "Ilgums",
    "from_average": "no vidējā",
    "ai_expert": "MI eksperts",
    "ai_evaluation_in_progress": "Notiek MI vērtējums",
    "delete_ai_request": "Dzēst MI atsauksmi",
    "ai_expert_refresh": "Atjaunināt MI rezultātus",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Šobrīd MI rezultātus nevar atjaunināt: vēl notiek MI vērtējums.",
      "answer_pending": "Šobrīd MI rezultātus nevar atjaunināt: MI atbilde vēl nav saņemta.",
      "recognition_pending": "Šobrīd MI rezultātus nevar atjaunināt: ieraksts vēl tiek transkribēts.",
      "recognition_has_no_speech": "Ierakstā netika atpazīta runa, tāpēc MI rezultātus nevar atjaunināt.",
      "recognition_has_too_little_speech": "Ierakstā gandrīz nav dalībnieku sarunas, tāpēc MI vērtējums netika veikts.",
      "no_ai_evaluation": "Šai sesijai vairs nav MI vērtējuma.",
      "game_evaluation_blocked": "Sesija nenotika vai tika anulēta, tāpēc MI vērtējums nav pieejams."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Ierakstā netika atpazīta runa, tāpēc MI vērtējums netika veikts.",
      "recognition_has_too_little_speech": "Ierakstā gandrīz nav dalībnieku sarunas, tāpēc MI vērtējums netika veikts.",
      "game_evaluation_blocked": "Sesija nenotika vai tika anulēta, tāpēc MI vērtējums nav pieejams."
    },
    "ai_expert_refresh_failed": "Neizdevās atjaunināt MI rezultātus.",
    "speaker_mapping": {
      "title": "Dalībnieki un balsis",
      "voice": "Balss {number}",
      "unknown": "Nav noteikts",
      "needs_review": "Pārbaudiet dalībniekus",
      "needs_review_hint": "Dalībnieki, iespējams, tika noteikti nepareizi: pārliecinieties, ka MI atsauksme nonāca pie pareizajiem cilvēkiem.",
      "failed": "Neizdevās automātiski noteikt dalībniekus.",
      "unavailable": "MI pakalpojumu sniedzējs nebija pieejams; dalībnieki tiks noteikti nākamajā vērtēšanas reizē.",
      "empty": "Transkripcijā nav runas, pēc kuras varētu noteikt dalībniekus.",
      "corrected_manually": "Manuāli izlabots",
      "under_reevaluation": "Notiek MI vērtējums ar šiem dalībniekiem. Kamēr tas nav pabeigts, lapā redzami iepriekšējie rezultāti.",
      "confirm": "Dalībnieki ir pareizi",
      "review": "Pārbaudīt",
      "dialog_hint": "Piešķiriet katrai balsij dalībnieku. Pēc saglabāšanas MI atsauksme tiks pieprasīta atkārtoti.",
      "save": "Saglabāt",
      "cancel": "Atcelt",
      "confirmed": "Dalībnieki apstiprināti",
      "fixed": "Dalībnieki izlaboti, MI atsauksme pieprasīta atkārtoti",
      "action_failed": "Neizdevās izpildīt darbību"
    },
    "ai_expert_created": "Sesijas vērtēšana ir sākta. Tas aizņems dažas minūtes. Varat pamest lapu — mēs jums paziņosim, kad vērtējums būs gatavs.",
    "expert_already_requested": "Vērtējumu jau pieprasīja cits dalībnieks",
    "request_expert": "Pieprasīt ekspertu",
    "assign_expert": "Piešķirt ekspertu",
    "ai_process": "Lūdzu, uzgaidiet, notiek apstrāde",
    "analyzing_results": "Notiek sesijas rezultātu analīze...",
    "complete_expert_request": "Pabeigt vērtējumu",
    "tabs": {
      "description": {
        "title": "Scenārija Apraksts",
        "subtitle": "Sesijas informācija un noteikumi",
        "situation": "Situācija",
        "your_role": "Jūsu loma",
        "player_role": "Spēlētāja loma: {name}",
        "team_tab": "Komanda {team}",
        "empty": "Šajā sesijā nav aprakstu.",
        "load_error": "Neizdevās ielādēt aprakstu. Lūdzu, mēģiniet vēlreiz vēlāk."
      },
      "results": {
        "title": "Rezultāti",
        "effectiveness_summary": "Komandas efektivitāte",
        "your_effectiveness": "Jūsu efektivitāte",
        "parameters_section": "Parametri",
        "parameter": "Parametrs",
        "target": "Mērķis",
        "coefficient": "Koeficients",
        "value": "Vienošanās",
        "points": "Punkti",
        "points_short": "punkti",
        "combinations": "Kombinācijas",
        "combination_bonus": "Kombināciju bonuss",
        "questions": "Jautājumi",
        "question": "Jautājums",
        "answer": "Atbilde",
        "total": "Kopā"
      },
      "comments": {
        "title": "Video analīze",
        "comments": "Komentāri",
        "no_comments": "Komentāru vēl nav",
        "no_video": "Video nav pieejams",
        "video_processing": "Video tiek apstrādāts...",
        "count": "komentāri",
        "delete": "Dzēst",
        "edit": "Rediģēt",
        "popup": {
          "add": "Pievienot komentāru",
          "edit": "Rediģēt komentāru",
          "comment": "Komentārs",
          "player": "Dalībnieks",
          "all": "Visiem"
        }
      },
      "feedback": {
        "title": "Sesijas vērtējums",
        "no_feedback": "Vēl nav vērtējumu",
        "no_feedback_description": "Atsauksmes par šo sesiju vēl nav pievienotas",
        "overall_score": "Kopējais vērtējums",
        "skills_evaluated": "Novērtētas {count} prasmes",
        "no_comment": "Nav sniegts komentārs",
        "score_button": "Vērtēt dalībnieku",
        "player": "Dalībnieks",
        "author": "Autors",
        "download": "Lejupielādēt video",
        "download_transcript": "Lejupielādēt transkripciju",
        "evaluators": {
          "ai": "MI eksperts",
          "expert": "Eksperts",
          "player": "Dalībnieks",
          "manager": "Vadītājs",
          "head": "Vadītājs"
        },
        "popup": {
          "score": {
            "title": "Dalībnieka vērtējums",
            "comment": "Komentārs",
            "error": "Jums jānovērtē visas prasmes",
            "save_error": "Neizdevās saglabāt vērtējumu. Iespējams, jums nav tiesību vērtēt šo dalībnieku."
          }
        }
      },
      "checklist": {
        "title": "Kontrolsaraksts",
        "total": "Izpildītie punkti",
        "pass": "Izpildīts",
        "fail": "Nav izpildīts",
        "cannot_assess": "Nevar novērtēt",
        "comment": "Vispārīgs komentārs",
        "category": "Kategorija",
        "author": "Vērtētājs",
        "player": "Dalībnieks",
        "passed_of": "{passed} no {total}",
        "evidence": "Pierādījums",
        "rationale": "Pamatojums",
        "no_results": "Vērtējums pēc kontrolsaraksta vēl nav gatavs",
        "no_results_description": "Šī sesija vēl nav vērtēta pēc kontrolsaraksta"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Izveidot jaunu",
        "edit_ai_profile": "Rediģēt",
        "delete_ai_profile": "Dzēst",
        "confirm_delete_ai_profile": "Vai tiešām vēlaties dzēst šo MI profilu?",
        "first_header": "Pamata iestatījumi",
        "second_header": "MI dalībnieks",
        "third_header": "Scenārija apraksts",
        "is_public": "Publisks",
        "is_public_hint": "Ja iespējots — scenārijs būs pieejams dalībnieku izvēlei.",
        "title": "Informācija",
        "subtitle": "Pamatinformācija par scenāriju",
        "image": "Scenārija attēls",
        "field_title": "Nosaukums",
        "competence": "Kompetence",
        "description": "Apraksts",
        "description_a": "Komandas A apraksts",
        "description_b": "Komandas B apraksts",
        "next_scenario_label": "Nākamais scenārijs",
        "next_scenario_placeholder": "Nav izvēlēts",
        "next_scenario_hint": "Pēc sesijas pabeigšanas ar šo scenāriju, automātiski tiks izveidota sesija ar nākamo scenāriju.",
        "memory_header": "Saikne ar nākamo tikšanos",
        "memory_group_evaluation": "Nākamās tikšanās vērtējums",
        "memory_group_character": "Nākamās tikšanās varonis",
        "memory_pass_to_next": "atceras šo tikšanos",
        "memory_pass_to_next_hint": "Nākamā scenārija varonis sāk sarunu tā, it kā runātu ar jau pazīstamu cilvēku: viņš saņem īsu šīs tikšanās kopsavilkumu, panāktās vienošanās, abu pušu solījumus, atklātos jautājumus un minētos faktus. Ieraksts un burtiski citāti viņam netiek nodoti. Iespējojiet šo iestatījumu, ja nākamā tikšanās turpina šo: otrā sarunu kārta, regulāra individuāla tikšanās.",
        "memory_pass_evaluation_to_next": "zina šīs tikšanās vērtējumu",
        "memory_pass_evaluation_to_next_hint": "Kopā ar atmiņu varonis saņem prasmju atgriezeniskās saites tekstus un šīs tikšanās kopējo rezultātu, tāpēc tas var uzvesties kā treneris, kurš atceras, kas spēlētājam izdevās.",
        "memory_evaluate_next_with_agreements": "ņem vērā šīs tikšanās vienošanās",
        "memory_evaluate_next_with_agreements_hint": "Vērtējot nākamo tikšanos, MI eksperts redz šīs tikšanās vienošanās, abu pušu solījumus un atklātos jautājumus, un var pārbaudīt, vai spēlētājs izpildīja doto solījumu. Iepriekšējās tikšanās vērtējuma punkti un teksti netiek nodoti tālāk, lai tie neietekmētu jauno vērtējumu.",
        "ai_profile": "MI profils",
        "ai_profile_placeholder": "Tikai MI sesijām",
        "ai_description": "MI apraksts",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Efektīva AI uzvednes rakstīšana prasa pieredzi. Slikti uzrakstīta uzvedne var izraisīt neparedzamu scenārija uzvedību. Ja neesat pārliecināts, izmantojiet pogu «Optimizēt ar MI», izmēģiniet scenāriju ģenerēšanu vai sazinieties ar savu vadītāju.",
        "knowledge_base_header": "Zināšanu bāze",
        "knowledge_base_documents": "Zināšanu bāzes dokumenti",
        "knowledge_base_documents_hint": "Pievienojiet dokumentus, lai nodrošinātu kontekstu MI spēlētājam",
        "knowledge_base_no_documents": "Nav pieejamu dokumentu. Augšupielādējiet dokumentus lapā \"Zināšanu bāze\".",
        "knowledge_base_chunks": "{count} fragments(-i)",
        "knowledge_base_purpose_voice": "MI sesija",
        "knowledge_base_purpose_eval": "Vērtēšana"
      },
      "settings": {
        "title": "Iestatījumi",
        "subtitle": "Scenārija konfigurācija",
        "min_players": "Minimālais dalībnieku skaits",
        "min_players_hint": "Skaitlis no 2 līdz 20",
        "max_players": "Maksimālais dalībnieku skaits",
        "max_players_hint": "Skaitlis no 2 līdz 20",
        "protocol_time": "Protokola laiks (min)",
        "protocol_time_hint": "Skaitlis no 1 līdz 1440",
        "preparation_time": "Sagatavošanās laiks (min)",
        "preparation_time_hint": "No 0 līdz 1440. 0 - apraksts redzams uzreiz",
        "game_duration": "Sesijas ilgums (min)",
        "game_duration_hint": "Skaitlis no 1 līdz 60",
        "is_team": "Scenārijs komandām",
        "is_camera_required": "Nepieciešamas dalībnieku kameras",
        "is_self_rated": "Dalībnieki var vērtēt sevi",
        "is_each_other_rated": "Dalībnieki var vērtēt cits citu",
        "is_expert_rated": "Eksperta vērtējums pieejams",
        "is_ai_rated": "MI vērtējums pieejams",
        "show_results": "Rādīt rezultātus",
        "automatically": "automātiski",
        "manually": "manuāli"
      },
      "parameters": {
        "title": "Parametri",
        "subtitle": "Dalībnieka parametri",
        "field_title": "Nosaukums",
        "team_a": "Komanda A",
        "team_b": "Komanda B",
        "player_a": "Dalībnieks A",
        "player_b": "Dalībnieks B",
        "points": "Punkti",
        "ratio": "Koeficients",
        "add": "Pievienot parametru"
      },
      "questions": {
        "title": "Jautājumi",
        "subtitle": "Jautājumi dalībniekiem",
        "question": "Jautājums",
        "team": "Komanda",
        "team_placeholder": "Izvēlēties komandu",
        "answers": "Atbildes",
        "points": "Punkti",
        "select_answers": "Izvēlēties atbildes",
        "add_combination": "Pievienot kombināciju",
        "add_question": "Pievienot jautājumu"
      },
      "next": "Nākamais",
      "previous": "Iepriekšējais",
      "save": "Saglabāt"
    },
    "saved": "Scenārijs saglabāts",
    "to_list": "Atpakaļ uz sarakstu",
    "add_detail": "Pievienot scenāriju",
    "edit_detail": "Rediģēt scenāriju"
  },
  "notifications": {
    "title": "Paziņojumi",
    "mark_unread": "Atzīmēt visus kā nelasītus",
    "mark_read": "Atzīmēt visus kā lasītus",
    "delete_all": "Dzēst visus",
    "no_new": "Nav jaunu paziņojumu",
    "system": "Sistēma",
    "evaluation": {
      "ready": {
        "subject": "Sesijas #:gameNumber vērtējums",
        "text": "Eksperts ir novērtējis sesiju"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Jums ir piešķirta sesija",
        "role": "Loma:"
      },
      "proposal": {
        "subject": "Sesijas laika saskaņošana",
        "time": "Laiks:",
        "description": "Lūdzu, apstipriniet vai iesniedziet savu variantu"
      },
      "agreed": {
        "subject": "Sesijas laiks saskaņots",
        "time": "Laiks:",
        "description": "Apraksts un sagatavošanās iespējas būs pieejamas :preparationTime minūtes pirms sākuma",
        "description_zero": "Jūs jau varat apskatīt scenārija aprakstu un sagatavoties"
      },
      "preparation": {
        "subject": "Sagatavošanās sesijai",
        "text": "Sagatavošanās sesijai ir pieejama."
      },
      "started": {
        "subject": "Sesija #:gameNumber ir sākusies",
        "text": "Pievienojieties!"
      },
      "missed": {
        "subject": "Sesija #:gameNumber nokavēta",
        "text": "Diemžēl jūs nokavējāt sesiju"
      },
      "completed": {
        "subject": "Sesija #:gameNumber pabeigta",
        "text": "Sesija veiksmīgi pabeigta"
      },
      "failed": {
        "subject": "Sesija #:gameNumber neizdevās",
        "text": "Sesija pabeigta neveiksmīgi"
      },
      "results": {
        "proposed": {
          "subject": "Sesijas #:gameNumber protokols saskaņots",
          "text": "Vienošanās pieejama"
        },
        "declined": {
          "subject": "Sesijas #:gameNumber protokols noraidīts",
          "text": "Piedāvājums noraidīts"
        },
        "not_agreed": {
          "subject": "Sesija #:gameNumber: puses nevienojās",
          "text": "Pretinieka kapteinis atzīmēja, ka puses nevienojās. Sesija beidzās neveiksmīgi un rezultāti netika ieskaitīti."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Sesijas sanāksme #:gameNumber pabeigta",
          "text": "Lūdzu, uzgaidiet rezultātus."
        },
        "ended-captain": {
          "subject": "Sesijas sanāksme #:gameNumber pabeigta",
          "text_fill": "Lūdzu, aizpildiet protokolu.",
          "text_wait": "Lūdzu, uzgaidiet, kamēr protokols tiks aizpildīts.",
          "protocol_time": "Protokola laiks (minūtēs): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "Atļauti JPG, GIF vai PNG faili. Maksimālais izmērs 2MB",
    "avatar_label_choose": "Izvēlēties",
    "avatar_label_your_avatar": "jūsu avatars",
    "name": "Vārds",
    "last_name": "Uzvārds",
    "patronymic": "Tēvavārds",
    "phone": "Telefons",
    "timezone": "Laika josla",
    "language": "Valoda",
    "country": "Valsts",
    "invalid_phone": "Nepareizs telefona numurs",
    "save_changes": "Saglabāt izmaiņas",
    "account": "Konts",
    "security": "Drošība",
    "statistics": "Statistika",
    "notifications": "Paziņojumi",
    "change_password_title": "Mainīt paroli",
    "change_password": "Mainīt paroli",
    "current_password": "Pašreizējā parole",
    "new_password": "Jauna parole",
    "confirm_new_password": "Apstiprināt jauno paroli",
    "password_requirements": "Paroles prasības:",
    "password_requirements_1": "Vismaz 8 simboli - jo vairāk, jo labāk",
    "password_requirements_2": "Vismaz viena mazā burta rakstzīme",
    "password_requirements_3": "Vismaz viens cipars, simbols vai atstarpe",
    "two_factor_title": "Divfaktoru autentifikācija",
    "two_factor_description": "Pievienojiet savam kontam papildu drošības līmeni",
    "two_factor_org_enforced": "Divfaktoru autentifikācija ir obligāta jūsu organizācijā",
    "two_factor_method": "Autentifikācijas metode",
    "two_factor_disabled": "Atspējota",
    "two_factor_email": "E-pasts",
    "two_factor_sms": "SMS",
    "two_factor_save": "Saglabāt 2FA iestatījumus"
  },
  "auth": {
    "password": "Parole",
    "new_password": "Jauna parole",
    "remember": "Atcerēties mani",
    "timezone": "Laika josla",
    "forgot": "Aizmirsi paroli",
    "login": "Pieteikties",
    "login_title": "Pieteikšanās",
    "new_password_title": "Mainīt paroli",
    "change_password": "Saglabāt",
    "country": "Valsts",
    "invalid_phone": "Nepareizs telefona numurs",
    "privacy_policy_title": "Privātuma politika",
    "privacy_policy_text": "Privātuma politikas teksts...",
    "first_time": "Pirmo reizi mūsu platformā?",
    "registration": "Izveidot kontu",
    "forgot_title": "Aizmirsi paroli?",
    "forgot_description": "Ievadiet savu e-pastu, un mēs nosūtīsim instrukcijas paroles atiestatīšanai",
    "send_reset_link": "Sūtīt paroles atiestatīšanas saiti",
    "back_to_login": "Atpakaļ uz pieteikšanos",
    "register": "Reģistrēties",
    "name": "Vārds",
    "last_name": "Uzvārds",
    "patronymic": "Tēvavārds",
    "phone": "Telefons",
    "enter_password": "Ievadiet paroli",
    "confirm_password": "Apstipriniet paroli",
    "not_first_time": "Jau ir konts?",
    "agree_too": "Es piekrītu",
    "privacy_policy": "privātuma politikai un noteikumiem",
    "accept": " Es piekrītu ",
    "password_validation": "Laukam jāiekļauj vismaz viena lielā, mazā burta rakstzīme, speciāla rakstzīme un cipars, vismaz 8 simboli",
    "password_confirm_error": "Apstiprinājuma parole nesakrīt",
    "set_password": "Iestatīt jaunu paroli",
    "reset_password": "Atiestatīt paroli",
    "for": "priekš",
    "sign_in_to_for": "Pieteikties {app} uzņēmumam {org}",
    "registration_title": "Reģistrācija",
    "verify_title": "E-pasta apstiprināšana",
    "verify_head": "Apstipriniet savu e-pastu",
    "verify_description": "Konts tika izveidots, un aktivizācijas saite nosūtīta uz jūsu e-pastu. Lūdzu, sekojiet saitei, lai turpinātu.",
    "verify_new_link": "Jauna verifikācijas saite tika nosūtīta uz reģistrācijas laikā norādīto e-pastu.",
    "verify_send": "Nosūtīt jaunu apstiprinājuma e-pastu",
    "verify_spam": "Jūs veicāt pārāk daudz pieprasījumu, lūdzu, mēģiniet vēlreiz pēc minūtes",
    "verify_logout": "Izrakstīties",
    "two_factor_title": "Divfaktoru autentifikācija",
    "two_factor_description_email": "Mēs nosūtījām verifikācijas kodu uz jūsu e-pasta adresi. Lūdzu, ievadiet kodu zemāk.",
    "two_factor_description_sms": "Mēs nosūtījām verifikācijas kodu uz jūsu telefona numuru. Lūdzu, ievadiet kodu zemāk.",
    "two_factor_code_label": "Verifikācijas kods",
    "two_factor_code_placeholder": "Ievadiet 6 ciparu kodu",
    "two_factor_verify": "Verificēt",
    "two_factor_resend": "Nosūtīt kodu vēlreiz",
    "two_factor_resend_success": "Jauns kods ir nosūtīts",
    "two_factor_back": "Atpakaļ uz pieteikšanos"
  },
  "filepond": {
    "upload": "Augšupielādēt",
    "upload_complete": "Augšupielāde pabeigta",
    "uploading": "Augšupielādējas",
    "loading": "Ielādējas",
    "tap_to_cancel": "pieskarieties, lai atceltu",
    "tap_to_undo": "pieskarieties, lai atsauktu",
    "upload_aborted": "Augšupielāde atcelta",
    "file_too_large": "Fails ir pārāk liels"
  },
  "text-editor": {
    "image": "Vienkārši velciet un nometiet attēlu redaktorā"
  },
  "webrtc": {
    "ready_to_start": "Gatavs sākt",
    "connected": "Savienots - Runājiet tagad!",
    "connection_lost": "Savienojums zaudēts. Lūdzu, mēģiniet vēlreiz."
  },
  "device_settings": {
    "title": "Audio un video ierīču iestatījumi",
    "speaker": "Skaļrunis/Audio izeja",
    "refresh_devices": "Atjaunināt ierīces",
    "speaker_switch_unsupported": "Skaļruņa pārslēgšana nav atbalstīta šajā pārlūkprogrammā"
  },
  "device_setup": {
    "mic_level": "Mikrofona līmenis",
    "mic_on": "Iesl",
    "mic_off": "Izsl",
    "cam_on": "Iesl",
    "cam_off": "Izsl"
  },
  "device_test": {
    "title": "Pārbaudīt audio ierīces",
    "speaker_test": "Skaļruņa pārbaude",
    "speaker_hint": "Noklikšķiniet uz pogas, lai atskaņotu testa skaņas caur izvēlēto skaļruni",
    "play_sound": "Atskaņot testa skaņu",
    "playing": "Atskaņo...",
    "speaker_success": "Skaņa atskaņota ✓",
    "mic_test": "Mikrofona pārbaude",
    "mic_hint": "Noklikšķiniet uz pogas un runājiet mikrofonā, lai pārbaudītu, vai tas darbojas",
    "volume_level": "Skaļuma līmenis",
    "speak_now": "Runājiet tagad...",
    "seconds_short": "s",
    "start_mic_test": "Pārbaudīt mikrofonu",
    "testing": "Pārbauda...",
    "test_again": "Pārbaudīt vēlreiz",
    "mic_success": "Mikrofons darbojas pareizi!",
    "mic_fail": "Konstatēta mikrofona problēma",
    "mic_fail_hint": "Skaņa netika konstatēta. Lūdzu, pārbaudiet, vai mikrofons ir pievienots, nav izslēgts un iestatījumos ir pareizi izvēlēts."
  },
  "ai_assistant_types": {
    "type": "Tips",
    "negotiation": "Sarunu",
    "feedback": "Atgriezeniskā saite",
    "ai_profile": "Sesija ar MI"
  },
  "Login": "Pieteikšanās",
  "UI Elements": "UI elementi",
  "Forms & Tables": "Formas un Tabulas",
  "Welcome": "Laipni lūgti",
  "Pages": "Lapas",
  "Charts & Maps": "Diagrammas un Kartes",
  "Others": "Citi",
  "Typography": "Tipogrāfija",
  "Cards": "Kartītes",
  "Basic": "Pamata",
  "Advance": "Paplašināts",
  "Widgets": "Logdaļas",
  "Components": "Komponentes",
  "Alert": "Brīdinājums",
  "Close Alert": "Aizvērt brīdinājumu",
  "Avatar": "Avatars",
  "Badge": "Žetons",
  "Button": "Poga",
  "Calendar": "Kalendārs",
  "Image": "Attēls",
  "Pagination": "Lappušu numerācija",
  "Progress Circular": "Cirkulārā progresija",
  "Progress Linear": "Lineārā progresija",
  "Autocomplete": "Automātiskā pabeigšana",
  "Tooltip": "Padoms",
  "Slider": "Slīdnis",
  "Date Time Picker": "Datuma un laika izvēlne",
  "Select": "Izvēlēties",
  "Switch": "Pārslēgt",
  "Checkbox": "Atzīmēšanas rūtiņa",
  "Radio": "Radio poga",
  "Textarea": "Teksta lauks",
  "Rating": "Vērtējums",
  "File Input": "Faila ievade",
  "Otp Input": "OTP ievade",
  "Form Layout": "Formas izkārtojums",
  "Form Validation": "Formas validācija",
  "Charts": "Diagrammas",
  "Apex Chart": "Apex diagramma",
  "Chartjs": "Chart.js diagramma",
  "Account Settings": "Konta iestatījumi",
  "User Profile": "Lietotāja profils",
  "FAQ": "BUJ",
  "Dialog Examples": "Dialogu piemēri",
  "Pricing": "Cenas",
  "List": "Saraksts",
  "Edit": "Rediģēt",
  "Nav Levels": "Navigācijas līmeņi",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Sazināties ar atbalstu",
  "Documentation": "Dokumentācija",
  "Dashboards": "Paneļi",
  "Analytics": "Analītika",
  "Apps & Pages": "Lietotnes un Lapas",
  "Email": "E-pasts",
  "Chat": "Čats",
  "Invoice": "Rēķins",
  "Preview": "Priekšskatījums",
  "Add": "Pievienot",
  "User": "Lietotājs",
  "View": "Skatīt",
  "Login v1": "Pieteikšanās v1",
  "Login v2": "Pieteikšanās v2",
  "Register v1": "Reģistrācija v1",
  "Register v2": "Reģistrācija v2",
  "Register": "Reģistrēties",
  "Forget Password v1": "Aizmirsta parole v1",
  "Forget Password v2": "Aizmirsta parole v2",
  "Forgot Password v1": "Aizmirsta parole v1",
  "Forgot Password v2": "Aizmirsta parole v2",
  "Forgot Password": "Aizmirsta parole",
  "Reset Password v1": "Paroles atiestatīšana v1",
  "Reset Password v2": "Paroles atiestatīšana v2",
  "Reset Password": "Paroles atiestatīšana",
  "Miscellaneous": "Dažādi",
  "Coming Soon": "Drīzumā",
  "Not Authorized": "Nav autorizēts",
  "Under Maintenance": "Apkope notiek",
  "Error": "Kļūda",
  "Statistics": "Statistika",
  "Actions": "Darbības",
  "Access Control": "Piekļuves kontrole",
  "User Interface": "Lietotāja saskarne",
  "CRM": "CRM",
  "eCommerce": "E-komercija",
  "Icons": "Ikonas",
  "Chip": "Žetons",
  "Dialog": "Dialogs",
  "Expansion Panel": "Paplašināšanas panelis",
  "Combobox": "Kombokaste",
  "Textfield": "Teksta lauks",
  "Range Slider": "Diapazona slīdnis",
  "Menu": "Izvēlne",
  "Snackbar": "Paziņojumu josla",
  "Tabs": "Cilnes",
  "Form Elements": "Formas elementi",
  "Form Layouts": "Formu izkārtojumi",
  "Authentication": "Autentifikācija",
  "Page Not Found - 404": "Lapa nav atrasta - 404",
  "Not Authorized - 401": "Nav autorizēts - 401",
  "Server Error - 500": "Servera kļūda - 500",
  "2": "2",
  "Forms": "Formas",
  "Timeline": "Laika līnija",
  "Disabled Menu": "Atspējota izvēlne",
  "Help Center": "Palīdzības centrs",
  "Verify Email": "Apstiprināt e-pastu",
  "Verify Email v1": "Apstiprināt e-pastu v1",
  "Verify Email v2": "Apstiprināt e-pastu v2",
  "Two Steps": "Divu soļu pārbaude",
  "Two Steps v1": "Divu soļu pārbaude v1",
  "Two Steps v2": "Divu soļu pārbaude v2",
  "Custom Input": "Pielāgota ievade",
  "Extensions": "Paplašinājumi",
  "Tour": "Tūre",
  "Register Multi-Steps": "Vairāku soļu reģistrācija",
  "Wizard Examples": "Vedņa piemēri",
  "Checkout": "Norēķināšanās",
  "Create Deal": "Izveidot darījumu",
  "Property Listing": "Īpašumu saraksts",
  "Roles & Permissions": "Lomas un atļaujas",
  "Roles": "Lomas",
  "Simple Table": "Vienkārša tabula",
  "Tables": "Tabulas",
  "Data Table": "Datu tabula",
  "Permissions": "Atļaujas",
  "Apps": "Lietotnes",
  "Misc": "Dažādi",
  "Wizard Pages": "Vedņa lapas",
  "Form Wizard": "Formu vednis",
  "Numbered": "Numurēts",
  "3": "3",
  "ecommerce": "e-komercija",
  "Ecommerce": "E-komercija",
  "Editors": "Redaktori",
  "Front Pages": "Priekšlapas",
  "Landing": "Galvenā lapa",
  "checkout": "norēķināšanās",
  "Payment": "Maksājums",
  "Swiper": "Karuselis",
  "Product": "Produkts",
  "Category": "Kategorija",
  "Order": "Pasūtījums",
  "Details": "Detaļas",
  "Customer": "Klients",
  "Manage Review": "Pārvaldīt atsauksmes",
  "Referrals": "Ieteikumi",
  "Settings": "Iestatījumi",
  "Overview": "Pārskats",
  "My Course": "Mans kurss",
  "Course Details": "Kursa detaļas",
  "Academy": "Akadēmija",
  "Logistics": "Loģistika",
  "Dashboard": "Panelis",
  "Fleet": "Transports",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Apkope",
  "maintenance-page": {
    "title": "Apkopes iestatījumi",
    "notification_section": "Globāls paziņojums",
    "notification_placeholder": "Ievadiet paziņojuma ziņojumu visiem lietotājiem",
    "notification_hint": "Šis ziņojums tiks parādīts visiem autentificētiem lietotājiem kā brīdinājums",
    "games_section": "Sesiju bloķēšana",
    "games_blocked_label": "Bloķēt jaunas sesijas",
    "games_blocked_hint": "Ja iespējots, lietotāji nevar izveidot vai sākt jaunas sesijas. Esošajām sesijām joprojām var pievienoties.",
    "save": "Saglabāt",
    "clear": "Notīrīt",
    "clear_confirm": "Vai tiešām vēlaties notīrīt paziņojumu?",
    "last_updated": "Pēdējoreiz atjaunināts",
    "updated_by": "atjaunināja",
    "games_blocked_message": "Atvainojamies par sagādātajām neērtībām. Platforma pašlaik tiek apkalpota. Sesijas ir īslaicīgi nepieejamas."
  },
  "$vuetify": {
    "badge": "Žetons",
    "noDataText": "Nav pieejamu datu",
    "close": "Aizvērt",
    "open": "Atvērt",
    "carousel": {
      "ariaLabel": {
        "delimiter": "atdalītājs"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Vienumu skaits lapā:",
      "itemsPerPageAll": "Visi",
      "pageText": "{0}-{1} no {2}",
      "firstPage": "Pirmā lapa",
      "prevPage": "Iepriekšējā lapa",
      "nextPage": "Nākamā lapa",
      "lastPage": "Pēdējā lapa"
    },
    "pagination": {
      "ariaLabel": {
        "root": "sakne",
        "previous": "iepriekšējā",
        "next": "nākamā",
        "first": "pirmā",
        "last": "pēdējā",
        "currentPage": "pašreizējā lapa",
        "page": "lapa"
      }
    },
    "input": {
      "clear": "notīrīt",
      "appendAction": "pievienot darbību",
      "prependAction": "pievienot priekšā darbību",
      "counterSize": "skaitītāja izmērs",
      "otp": "vienreizējs parole"
    },
    "fileInput": {
      "counterSize": "skaitītāja izmērs"
    },
    "rating": {
      "ariaLabel": {
        "item": "vienība"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Prasmju attīstības pārskats",
    "generate": "Ģenerēt",
    "generate_description": "Ģenerēt visaptverošu prasmju attīstības pārskatu par izvēlēto periodu",
    "manager_description": "Ģenerēt prasmju attīstības pārskatus jūsu organizācijas darbiniekiem",
    "date": "Datums",
    "competence": "Kompetence",
    "period": "Periods",
    "status_label": "Statuss",
    "actions": "Darbības",
    "employee": "Darbinieks",
    "view": "Skatīt pārskatu",
    "download_pdf": "Lejupielādēt PDF",
    "no_reports": "Vēl nav ģenerētu pārskatu",
    "data_not_available": "Pārskata dati vēl nav pieejami",
    "generation_failed": "Pārskata ģenerēšana neizdevās",
    "retry": "Mēģināt vēlreiz",
    "rate_limit_exceeded": "Pārskata ģenerēšanas limits sasniegts. Lūdzu, mēģiniet vēlāk.",
    "too_many_pending": "Jums ir pārāk daudz pārskatu izstrādē. Lūdzu, pagaidiet, kamēr tie tiks pabeigti.",
    "no_games_for_report": "Izvēlētajam periodam un kompetencei nav atrasta neviena pabeigta sesija. Pārskatu nevar ģenerēt.",
    "report_already_exists": "Pārskats ar šiem parametriem jau pastāv. Pārbaudiet zemāk esošo sarakstu.",
    "period_too_long": "Pārskata periods nedrīkst pārsniegt vienu gadu.",
    "invalid_parameters": "Pārbaudiet kompetenci un periodu",
    "filter_by_employee": "Filtrēt pēc darbinieka...",
    "batch": {
      "mode_single": "Viens pārskats",
      "mode_batch": "Pakete",
      "load_employees": "Rādīt darbiniekus",
      "sessions": "Sesijas",
      "no_candidates": "Izvēlētajai kompetencei un periodam nav neviena darbinieka ar pabeigtām sesijām",
      "generate_selected": "Izveidot ({count})",
      "selected_limit": "Vienlaikus var atlasīt ne vairāk kā {max} darbiniekus",
      "progress": "Gatavi {ready} no {total}",
      "failed_count": "Kļūdas: {count}",
      "status_unknown": "Statuss nezināms",
      "status_unknown_hint": "Pārskats sarakstā nav atrasts — skatiet pārskatu tabulu zemāk",
      "reused": "Atkārtoti izmantoti pārskati: {count} — izveidoti pēdējās {hours} h un netika veidoti no jauna",
      "reused_badge": "Atkārtoti izmantots",
      "reused_on": "Izveidots {date}",
      "download_all": "Lejupielādēt visu",
      "toggle_details": "Rādīt paketes saturu",
      "dismiss_confirm": "Šī pakete vēl tiek veidota. Vai noņemt to no ekrāna? Progress un poga “Lejupielādēt visu” tiks zaudēti, pārskati paliks sarakstā zemāk.",
      "archive_unavailable": "Neizdevās izveidot arhīvu: daļa pārskatu vēl nav gatavi vai vairs nav pieejami",
      "archive_failed": "Neizdevās lejupielādēt arhīvu",
      "archive_building": "Notiek arhīva izveide…",
      "archive_build_failed": "Neizdevās izveidot arhīvu. Mēģiniet vēlreiz.",
      "candidates_failed": "Neizdevās ielādēt darbinieku sarakstu",
      "stale_selection": "Daļa atlasīto darbinieku vairs nav pieejami. Saraksts ir atjaunināts — atlasiet vēlreiz."
    },
    "quota": {
      "remaining_hour": "Pārskatu limits — {limit} stundā. Tagad var pieprasīt vēl {remaining}. Atlasiet mazāk darbinieku vai mēģiniet vēlreiz {time}.",
      "remaining_day": "Pārskatu limits — {limit} dienā. Tagad var pieprasīt vēl {remaining}. Atlasiet mazāk darbinieku vai mēģiniet vēlreiz {time}.",
      "exhausted_hour": "Pārskatu limits ({limit} stundā) sasniegts. Tas atjaunosies {time}.",
      "exhausted_day": "Pārskatu limits ({limit} dienā) sasniegts. Tas atjaunosies {time}.",
      "too_large_hour": "Pārskatu limits — {limit} stundā. Atlasiet mazāk darbinieku.",
      "too_large_day": "Pārskatu limits — {limit} dienā. Atlasiet mazāk darbinieku."
    },
    "status": {
      "pending": "Gaida",
      "collecting_data": "Datu vākšana...",
      "analyzing": "MI analīze...",
      "generating_pdf": "PDF ģenerēšana...",
      "ready": "Gatavs",
      "failed": "Neizdevās"
    },
    "report": {
      "kicker": "Kompetences attīstības pārskats",
      "position": "Amats",
      "department": "Nodaļa",
      "period": "Periods",
      "games_count": "Veiktās sesijas",
      "not_specified_f": "Nav norādīta",
      "not_specified_n": "Nav norādīts",
      "fig": {
        "your_average": "Jūsu vidējais rezultāts",
        "company_average": "Uzņēmuma vidējais",
        "participants": "Dalībnieku periodā",
        "skills_count": "Novērtētas prasmes"
      },
      "sec": {
        "profile": "Kompetences profils",
        "trend": "Gaita pa sesijām",
        "strengths": "Uz ko balstīties",
        "priorities": "Trīs attīstības prioritātes",
        "skills": "Analīze pa prasmēm",
        "plan": "Trīs mēnešu plāns"
      },
      "legend": {
        "you": "Jūsu rezultāts",
        "company": "Uzņēmuma vidējais"
      },
      "dotplot_caption": "Novirze no vidējā — no lielākā pārsvara līdz lielākajai atpalicībai",
      "trend_disclaimer": "Atsevišķu sesiju rezultāti nav tieši salīdzināmi: gadījumu sarežģītība katrā sesijā atšķiras. Zemāks rezultāts pats par sevi nenozīmē prasmes pasliktināšanos — šis grafiks ir novērojums, nevis vērtējums.",
      "no_comparison": "Salīdzinājums ar uzņēmuma vidējo nav pieejams: periodā šajā kompetencē sesijas veica mazāk nekā trīs cilvēki. Pārskats balstīts uz absolūtajiem rezultātiem.",
      "skill": {
        "works": "Kas izdodas",
        "blocks": "Kas traucē",
        "actions": "Ko darīt",
        "out_of_ten": "no 10",
        "company_short": "uzņēmums"
      },
      "level": {
        "outstanding": "Izcils rezultāts",
        "strength": "Stiprā puse",
        "meets_standard": "Uzņēmuma līmenī",
        "needs_attention": "Nepieciešama uzmanība",
        "needs_development": "Attīstības joma"
      },
      "plan": {
        "month": "Mēnesis",
        "goals": "Mērķi",
        "actions": "Darbības"
      },
      "colophon": {
        "built_on": "Pārskats balstīts uz perioda {from} — {to} sesijām. Kopējais sesiju skaits: {count}.",
        "comparison": "Salīdzinājums veikts ar uzņēmuma vidējo tajā pašā periodā. Dalībnieku skaits: {count}."
      }
    }
  },
    "api-tokens": "API Marķieri",
    "api-tokens-page": {
        "select_user": "Lietotājs",
        "select_user_hint": "Atlasiet lietotāju, lai skatītu un pārvaldītu viņa API marķierus.",
        "no_users_found": "Lietotāji nav atrasti",
        "no_tokens": "Šim lietotājam nav API marķieru.",
        "token_name": "Nosaukums",
        "abilities": "Atļaujas",
        "ability": "Atļauja",
        "created_at": "Izveidošanas datums",
        "last_used_at": "Pēdējās izmantošanas datums",
        "expires_at": "Derīguma termiņš",
        "actions": " ",
        "issue_token": "Izsniegt marķieri",
        "issue": "Izsniegt",
        "issue_failed": "Marķiera izsniegšana neizdevās",
        "token": "Marķieris",
        "plaintext_warning": "Nokopējiet šo marķieri tūlīt — tas vairs netiks parādīts.",
        "revoke": "Atsaukt",
        "revoke_confirm": "Vai tiešām vēlaties atsaukt šo marķieri? Integrācijas, kas to izmanto, pārstās darboties."
    },
  "subscription": {
    "current_plan": "Pašreizējais plāns",
    "expires_at": "Beidzas: {date}",
    "no_active_plan": "Nav aktīva abonementa plāna",
    "quota_warning": "Atlikusi maz kvota",
    "regular_games": "Parastās sesijas",
    "ai_games": "MI sesijas",
    "any_games": "Jebkuras sesijas",
    "used_of": "{used} no {limit}",
    "remaining": "Atlikušas: {count}",
    "quota_exceeded": "Kvota pārsniegta",
    "tickets_only": "Kredītu paketes",
    "session_package": "Sesiju pakete",
    "games_available": "Sesijas",
    "users": "Lietotāji",
    "active_users": "Aktīvie lietotāji",
    "active_tickets": "Kredītu paketes",
    "ticket_charges": "{charges} kredīti",
    "ticket_no_expiry": "Bez termiņa",
    "unlimited": "Neierobežoti",
    "no_game_limits": "Nav ierobežojumu sesiju skaitam"
  },
  "knowledge-base-page": {
    "provider-unsupported": "Zināšanu bāze nav pieejama ar jūsu organizācijas pašreizējo AI pakalpojumu sniedzēju."
  },
  "candidate-page": {
    "document_title": "Intervija",
    "greeting": "Labdien, {name}!",
    "intro_lead": "{organization} aicina Jūs uz interviju ar virtuālo sarunu biedru vakancei «{vacancy}».",
    "duration": "Intervija ilgs apmēram {minutes} min.",
    "requirements_title": "Kas nepieciešams",
    "requirement_mic": "Strādājošs mikrofons, ieteicams — austiņas ar mikrofonu",
    "requirement_camera_required": "Ieslēgta kamera: šai intervijai tā ir obligāta",
    "requirement_camera_optional": "Kamera nav obligāta, bet ar to saruna norit dabiskāk",
    "requirement_browser": "Dators ar jaunāko Chrome, Edge vai Safari versiju",
    "requirement_network": "Stabils interneta pieslēgums un klusa vieta, kur neviens Jūs netraucēs",
    "continue": "Turpināt",
    "consent": {
      "accept": "Esmu iepazinies(-usies) ar tekstu un piekrītu savu personas datu apstrādei",
      "back": "Atpakaļ",
      "start": "Sākt interviju"
    },
    "terminal": {
      "finished": {
        "title": "Paldies!",
        "text": "Intervija ir pabeigta, rezultāts nodots rekrutierim — viņš ar Jums sazināsies. Šo lapu var aizvērt."
      },
      "already_completed": {
        "title": "Intervija jau pabeigta",
        "text": "Pēc šīs saites intervija jau ir pabeigta. Ja nepieciešams to veikt vēlreiz, sazinieties ar rekrutieri."
      },
      "not_found": {
        "title": "Saite nav atrasta",
        "text": "Iespējams, adresē ir kļūda vai saite vairs nav derīga. Pārbaudiet rekrutiera vēstuli vai sazinieties ar viņu."
      },
      "session_conflict": {
        "title": "Jūs esat pieslēdzies citam kontam",
        "text": "Izejiet no pašreizējā konta vai atveriet saiti pārlūka privātajā logā."
      },
      "link_revoked": {
        "title": "Piekļuve saitei ir slēgta",
        "text": "Rekrutieris ir atsaucis šo saiti. Sazinieties ar viņu, lai saņemtu jaunu."
      },
      "link_expired": {
        "title": "Saites derīguma termiņš ir beidzies",
        "text": "Sazinieties ar rekrutieri, lai viņš izsniegtu jaunu saiti."
      },
      "attempts_exhausted": {
        "title": "Mēģinājumi ir beigušies",
        "text": "Visi šai saitei pieejamie mēģinājumi ir izmantoti. Sazinieties ar rekrutieri."
      },
      "unavailable": {
        "title": "Pašlaik sākt nevar",
        "text": "Mēģiniet vēlāk vai sazinieties ar rekrutieri."
      },
      "rate_limited": {
        "title": "Pārāk daudz mēģinājumu",
        "text": "Uzgaidiet minūti un atsvaidziniet lapu."
      },
      "aborted": {
        "title": "Intervija nesākās",
        "text": "Atsvaidziniet lapu un mēģiniet vēlreiz. Ja tas nepalīdz — sazinieties ar rekrutieri."
      },
      "generic": {
        "title": "Kaut kas nogāja greizi",
        "text": "Atsvaidziniet lapu un mēģiniet vēlreiz. Ja tas nepalīdz — sazinieties ar rekrutieri."
      }
    }
  },
  "recruiting-page": {
    "title": "Personāla atlase",
    "create": "Jauna vakance",
    "edit": "Rediģēt vakanci",
    "empty": "Vakanču pagaidām nav",
    "load_error": "Neizdevās ielādēt vakanču sarakstu",
    "retry": "Mēģināt vēlreiz",
    "back": "Atpakaļ uz vakanču sarakstu",
    "open": "Kandidāti",
    "archive": "Arhivēt",
    "no_expiry": "Bez termiņa",
    "confirm_archive": "Arhivēt šo vakanci? Tai vairs nevarēs izsniegt jaunas saites.",
    "headers": {
      "title": "Vakance",
      "scenario": "Scenārijs",
      "status": "Statuss",
      "expires_at": "Derīguma termiņš",
      "actions": "Darbības"
    },
    "status": {
      "draft": "Melnraksts",
      "active": "Aktīva",
      "archived": "Arhivēta"
    },
    "dialog": {
      "title_label": "Vakances nosaukums",
      "scenario_label": "Intervijas scenārijs",
      "scenario_placeholder": "Izvēlieties scenāriju MI intervijai",
      "scenario_hint": "Pieejami tikai scenāriji, kas piemēroti sesijai pret MI",
      "status_label": "Statuss",
      "expires_label": "Derīguma termiņš",
      "expires_hint": "Ja atstāsiet tukšu, vakancei nebūs derīguma termiņa",
      "save": "Saglabāt",
      "cancel": "Atcelt"
    },
    "messages": {
      "created": "Vakance izveidota",
      "updated": "Vakance atjaunināta",
      "archived": "Vakance arhivēta",
      "revoked": "Saite atsaukta",
      "attempt_granted": "Kandidātam piešķirts vēl viens mēģinājums",
      "copied": "Saite nokopēta",
      "error": "Kaut kas nogāja greizi"
    },
    "candidates": {
      "title": "Kandidāti",
      "empty": "Šai vakancei vēl nav izsniegtu saišu",
      "load_error": "Neizdevās ielādēt kandidātu sarakstu",
      "issue": "Izsniegt saiti",
      "import": "Importēt no faila",
      "expired": "Beigusies",
      "no_games": "Intervija nav sākta",
      "attempts": "{used} no {allowed}",
      "revoke": "Atsaukt saiti",
      "extra_attempt": "Piešķirt vēl vienu mēģinājumu",
      "open_result": "Atvērt intervijas rezultātu",
      "confirm_revoke": "Atsaukt kandidāta saiti? Piekļuve tiks liegta nekavējoties, tostarp notiekošajai intervijai.",
      "confirm_extra_attempt": "Piešķirt kandidātam vēl vienu mēģinājumu?",
      "headers": {
        "candidate": "Kandidāts",
        "link_status": "Saite",
        "invite": "Uzaicinājums",
        "game_status": "Intervija",
        "attempts": "Mēģinājumi",
        "expires_at": "Saites derīguma termiņš",
        "actions": "Darbības"
      },
      "link_status": {
        "created": "Izsniegta",
        "opened": "Atvērta",
        "in_progress": "Notiek intervija",
        "completed": "Intervija pabeigta",
        "revoked": "Atsaukta"
      },
      "invite_status": {
        "not_sent": "Nav nosūtīts",
        "queued": "Rindā",
        "sent": "Nosūtīts",
        "failed": "Neizdevās nosūtīt"
      },
      "invite_sent_at": "E-pasta serviss pieņēma vēstuli: {date}",
      "invite_failure": {
        "rejected": "E-pasta serviss vēstuli noraidīja — nosūtiet saiti kandidātam paši",
        "transport": "Nosūtīšana neizdevās — nosūtiet saiti kandidātam paši",
        "revoked": "Saite tika atsaukta",
        "sending_disabled": "Vēstuļu sūtīšana ir izslēgta",
        "blocked": "Adrese ir stopsarakstā — nosūtiet saiti kandidātam paši"
      }
    },
    "issue_dialog": {
      "title": "Izsniegt personīgu saiti",
      "name": "Vārds",
      "last_name": "Uzvārds",
      "email": "E-pasts",
      "phone": "Telefons",
      "attempts": "Mēģinājumu skaits",
      "expires_at": "Saites derīguma termiņš",
      "expires_hint": "Ja atstāsiet tukšu, tiks izmantots vakances derīguma termiņš",
      "submit": "Izsniegt saiti",
      "close": "Aizvērt",
      "result_title": "Saite izsniegta",
      "warning": "Nokopējiet saiti tagad — tā tiek parādīta tikai vienu reizi. Datubāzē tiek glabāts tikai tās hešs, tāpēc saiti atjaunot nav iespējams: pazaudēta saite jāatsauc un jāizsniedz no jauna.",
      "copy": "Kopēt",
      "copied": "Nokopēts",
      "send_invite": "Nosūtīt uzaicinājumu uz {email}",
      "send_invite_no_email": "Nosūtīt uzaicinājumu pa e-pastu",
      "send_invite_blocked": "Šī adrese ir stopsarakstā — vēstule netiks nosūtīta",
      "invite_queued": "Uzaicinājums uz {email} ievietots rindā",
      "invite_blocked": "Uzaicinājums nav nosūtīts: {email} ir stopsarakstā. Nosūtiet saiti kandidātam paši"
    },
    "import_dialog": {
      "title": "Kandidātu imports",
      "subtitle": "Katra faila rindiņa ir viens kandidāts un viena personīga saite.",
      "file": "Kandidātu saraksta fails",
      "columns": "Kolonnas: Vārds, Uzvārds, E-pasts, Telefons",
      "limits": "xlsx vai CSV (;), līdz 200 rindām un 10 MB",
      "size_error": "Fails lielāks par 10 MB",
      "download_example": "Lejupielādēt veidni",
      "note_title": "Saites būs redzamas tikai lejupielādētajā failā",
      "note_text": "Fails lejupielādēsies uzreiz pēc importa pabeigšanas. Datubāzē tiek glabāts tikai saišu hešs, tāpēc otrreiz tās izgūt nevar — saglabājiet failu.",
      "submit": "Importēt",
      "cancel": "Atcelt",
      "result_title": "Saites izsniegtas",
      "result": "Izsniegtas saites: {count}. Fails lejupielādēts.",
      "invites_blocked": "Nenosūtīto uzaicinājumu skaits: {count}. Šīs adreses ir stopsarakstā — nosūtiet saites šiem kandidātiem paši.",
      "saved_title": "Saglabājiet lejupielādēto failu",
      "saved_text": "Tā ir vienīgā šo saišu kopija: datubāzē tiek glabāts tikai to hešs. Pazaudētu saiti var vienīgi atsaukt un izsniegt no jauna.",
      "download_again": "Lejupielādēt failu vēlreiz",
      "errors_title": "Noraidītās rindas",
      "error_row": "Rinda {row}: {error}",
      "errors_truncated": "…un vēl noraidītas rindas: {count}. Sarakstā redzamas pirmās 50.",
      "send_invites": "Nosūtīt uzaicinājumus kandidātiem pa e-pastu",
      "send_invites_hint": "Kandidāti bez e-pasta adreses vēstuli nesaņems"
    }
  },
  "ai-reports": "MI pārskati",
  "ai-reports-page": {
    "title": "MI pārskati",
    "subtitle": "Aprakstiet pārskatu saviem vārdiem — izveidosim specifikāciju, parādīsim priekšskatījumu un eksportēsim uz Excel.",
    "status": {
      "draft": "Melnraksts",
      "pending": "Tiek veidots",
      "ready": "Gatavs",
      "failed": "Neizdevās izveidot"
    },
    "list": {
      "title": "Mani pārskati",
      "new": "Jauns pārskats",
      "empty": "Pārskatu vēl nav. Nospiediet «Jauns pārskats» un aprakstiet, kas jāparāda.",
      "untitled": "Bez nosaukuma",
      "delete": "Dzēst pārskatu",
      "delete_confirm": "Dzēst pārskatu kopā ar izveidoto failu?",
      "deleted": "Pārskats dzēsts"
    },
    "dialog": {
      "title": "Dialogs",
      "open_dictionary": "Datu uzziņa",
      "placeholder": "Piemēram: cik spēļu katra nodaļa aizvadīja pēdējā ceturksnī",
      "send": "Sūtīt",
      "empty_title": "Kas jāparāda pārskatā?",
      "empty_text": "Uzrakstiet vienkāršiem vārdiem: kādi dati, par kādu periodu un kādā sadalījumā. Ja kaut kā trūks, pajautāšu.",
      "examples_title": "Piemēram:",
      "examples": {
        "e1": "Cik spēļu katra nodaļa aizvadīja pēdējā ceturksnī",
        "e2": "Vidējais prasmju vērtējums pārdošanas nodaļā 2026. gadā",
        "e3": "Darbinieki, kas nav spēlējuši ilgāk par mēnesi",
        "e4": "Kandidāti pēc vakances un viņu saišu statusiem pēdējo 30 dienu laikā"
      },
      "thinking": "Pārskats tiek veidots…",
      "waiting_hint": "Atbilde parādīsies šeit pati — lapa nav jāatjaunina.",
      "retry": "Mēģināt vēlreiz",
      "dismiss": "Paslēpt",
      "spec_ready": "Pārskats ir izveidots — pārbaudiet zemāk redzamo priekšskatījumu un izveidojiet failu.",
      "stuck_title": "Šķiet, ka griežamies pa apli",
      "stuck_text": "Apskatiet datu uzziņu un pārformulējiet pieprasījumu ar tajā lietotajiem vārdiem — tas ir ātrāk nekā atbildēt uz vēl vienu precizējošu jautājumu.",
      "rejected_title": "Šo pārskatu vēl nevar izveidot",
      "reason": {
        "no_such_measure": "Šāda rādītāja mūsu datos nav. Apskatiet rādītāju sarakstu uzziņā.",
        "no_such_field": "Šāda lauka mūsu datos nav. Apskatiet lauku sarakstu uzziņā.",
        "cross_dataset": "Pieprasījumam vajadzīgi dati vienlaikus no divām datu kopām. Sadaliet to divos pārskatos.",
        "window_function": "Daļas no kopsummas, vietas reitingā un salīdzinājums ar iepriekšējo periodu vēl netiek atbalstīti.",
        "other": "Pieprasījums pārsniedz pieejamos datus. Apskatiet uzziņu un mēģiniet citu formulējumu."
      },
      "usage": {
        "employees": "Nav darbinieku | {n} darbinieks | darbinieku: {n}",
        "games": "Nav spēļu | {n} spēle | spēļu: {n}",
        "scenarios": "Nav scenāriju | {n} scenārijs | scenāriju: {n}",
        "evaluations": "Nav vērtējumu | {n} vērtējums | vērtējumu: {n}",
        "candidates": "Nav kandidātu | {n} kandidāts | kandidātu: {n}"
      },
      "option_created_at": "pievienošanas datums: {date}"
    },
    "preview": {
      "title": "Priekšskatījums",
      "no_report": "Izvēlieties pārskatu kreisajā pusē vai sāciet jaunu.",
      "no_spec": "Aprakstiet pārskatu dialogā — priekšskatījums parādīsies, tiklīdz pieprasījums būs saprasts.",
      "spec_title": "Kas būs pārskatā",
      "rows_hint": "Rādītas pirmās {count} rindas",
      "total": "Rindu kopā: {count}",
      "zero_rows": "Šis pieprasījums neatgriež nevienu rindu. Paplašiniet periodu vai noņemiet filtrus — tukšu failu veidot nav jēgas.",
      "zero_rows_hint": "Pārbaudiet filtru vērtības — tām, iespējams, nav datu",
      "duplicate_rows": "Dažas priekšskatījuma rindas ir identiskas: izvēlētās kolonnas neatšķir šīs datu kopas ierakstus. Pārbaudiet, ko šeit patiesībā nozīmē viena rinda — iespējams, trūkst kolonnas, kas tās atšķir.",
      "too_many_rows": "Pārskatā ir {count} rindas, maksimums ir {max}. Sašauriniet periodu vai pievienojiet filtrus: pārsniedzot limitu, fails netiek izveidots vispār, nevis saīsināts.",
      "generate": "Izveidot failu",
      "regenerate": "Izveidot no jauna",
      "queued": "Fails tiek veidots — kartīte atjaunināsies pati, tiklīdz tas būs gatavs.",
      "failed": "Pārskatu neizdevās izveidot",
      "download": "Lejupielādēt .xlsx",
      "downloads": "Lejupielādes: {count}",
      "ttl_warning": "Fails tiek glabāts {days} dienas un pēc tam dzēsts — lejupielādējiet to uzreiz.",
      "expires_at": "Pieejams līdz {date}",
      "expired": "Fails dzēsts, beidzoties tā glabāšanas termiņam — izveidojiet pārskatu no jauna."
    },
    "spec": {
      "dataset": "Dati",
      "columns": "Kolonnas",
      "measures": "Rādītāji",
      "group_by": "Sadalījums",
      "period": "Periods",
      "period_value": "{field}: no {from} līdz {to}",
      "period_all": "Viss pieejamais periods",
      "filters": "Filtri",
      "having": "Nosacījumi rādītājiem",
      "sort": "Kārtošana",
      "limit": "Rindu ierobežojums",
      "limit_value": "pirmās {count} rindas",
      "granularity": {
        "year": "pa gadiem",
        "quarter": "pa ceturkšņiem",
        "month": "pa mēnešiem",
        "week": "pa nedēļām",
        "day": "pa dienām",
        "dow": "pa nedēļas dienām"
      },
      "dir": {
        "asc": "augošā secībā",
        "desc": "dilstošā secībā"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — nav {value}",
        "in": "{field} — viena no: {value}",
        "not_in": "{field} — izņemot: {value}",
        "gt": "{field} lielāks par {value}",
        "gte": "{field} vismaz {value}",
        "lt": "{field} mazāks par {value}",
        "lte": "{field} ne vairāk kā {value}",
        "contains": "{field} satur «{value}»",
        "between": "{field} — no {from} līdz {to}",
        "is_null": "{field} nav aizpildīts",
        "is_not_null": "{field} ir aizpildīts"
      }
    },
    "value": {
      "yes": "Jā",
      "no": "Nē"
    },
    "dictionary": {
      "title": "Datu uzziņa",
      "subtitle": "Viss, ko var iekļaut pārskatā. Saraksts ir aktuāls reāllaikā: tas ir tas pats, no kura tiek veidota specifikācija.",
      "fields": "Lauki",
      "measures": "Rādītāji",
      "values": "Vērtības",
      "show_values": "Rādīt jūsu organizācijas vērtības",
      "hide_values": "Slēpt vērtības",
      "values_error": "Neizdevās ielādēt vērtības — mēģiniet vēlreiz.",
      "values_empty": "Jūsu organizācijai vēl nav vērtību šim laukam.",
      "limits": {
        "title": "Ko pārskats nevar izdarīt",
        "pivot": "Kopsavilkuma tabula ar kolonnu katram dalībniekam vai katram jautājumam netiks izveidota. Tā vietā pieprasiet garo formu: rinda katram dalībnieka un jautājuma pārim.",
        "window": "Pārskats neaprēķina izmaiņas mēnesi pret mēnesi, daļu no kopsummas, vietu reitingā un «top trīs katrā nodaļā». Ņemiet sadalījumu pa mēnešiem un pabeidziet aprēķinu Excel.",
        "missing": "Kas sistēmā nav saglabāts, tas pārskatā neparādīsies: algas, NPS un citi citur glabāti dati neparādīsies ne ar kādu nosaukumu."
      },
      "empty": "Uzziņa ir tukša — sazinieties ar administratoru.",
      "close": "Aizvērt"
    },
    "errors": {
      "generic": "Kaut kas nogāja greizi. Mēģiniet vēlreiz.",
      "detail": "Nav saprasts: {value}",
      "rate_limit": "Pārāk daudz pieprasījumu. Uzgaidiet minūti un mēģiniet vēlreiz.",
      "download": "Failu neizdevās lejupielādēt.",
      "turn_failed": "Neizdevās saņemt atbildi. Nosūtiet pieprasījumu vēlreiz.",
      "turn_stuck_in_queue": "Pieprasījums netika apstrādāts — tas pārāk ilgi gaidīja rindā. Nosūtiet to vēlreiz.",
      "unknown_resolution": "Šī iespēja ir novecojusi — pārskats pa to laiku ir mainījies. Atveriet to vēlreiz un precizējiet pieprasījumu."
    }
  },
    "externalLaunch": {
        "document_title": "Treniņš",
        "intro": {
            "title": "Treniņa saruna",
            "lead": "Tagad jūs sarunāsieties ar virtuālu sarunu biedru. Saruna tiek ierakstīta un novērtēta, un rezultāts nonāks jūsu mācību sistēmā.",
            "requirements_title": "Kas jums būs nepieciešams",
            "requirement_mic": "Funkcionējošs mikrofons, vēlams austiņas ar mikrofonu",
            "requirement_camera": "Kamera nav obligāta, bet ar to saruna izdodas dabiskāka",
            "requirement_browser": "Dators ar aktuālu Chrome, Edge vai Safari versiju",
            "requirement_network": "Stabils savienojums un klusa vieta, kur jūs netraucēs",
            "start": "Sākt"
        },
        "relaunch_hint": "Atgriezieties savā mācību sistēmā un atveriet materiālu no jauna.",
        "saving": "Saglabājam rezultātu…",
        "review": {
            "document_title": "Sesijas pārskats",
            "attempt": "Mēģinājums {number}",
            "result": {
                "passed": "Nokārtots",
                "failed": "Nav nokārtots",
                "pending": "Vēl nav novērtēts"
            },
            "score_of_100": "{score} no 100",
            "threshold": "Nokārtošanas slieksnis: {threshold}",
            "skills_title": "Prasmes un ieteikumi",
            "skills_empty": "Šim mēģinājumam vēl nav prasmju izvērtējuma.",
            "comments_title": "Komentāri par ierakstu",
            "comments_empty": "Šim ierakstam komentāru nav.",
            "loading": "Ielādē pārskatu",
            "error": {
                "not_found": {
                    "title": "Saite nedarbojas",
                    "text": "Pārskats vairs nav pieejams: saites derīguma termiņš beidzies vai mēģinājums atsaukts."
                },
                "expired": {
                    "title": "Lapas derīguma termiņš beidzies",
                    "text": "Atveriet pārskatu no jauna, izmantojot saiti mācību sistēmā."
                },
                "generic": {
                    "title": "Neizdevās parādīt pārskatu",
                    "text": "Mūsu pusē kaut kas nogāja greizi. Mēģiniet atvērt saiti vēlreiz."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Paldies!",
                "text": "Saruna ir pabeigta. Rezultāts parādīsies jūsu mācību sistēmā, tiklīdz būs gatavs novērtējums. Šo lapu varat aizvērt."
            },
            "aborted": {
                "title": "Saruna nesākās",
                "text": "Pirms sarunas sākuma kaut kas nogāja greizi."
            },
            "token_expired": {
                "title": "Sesijas derīguma termiņš beidzies",
                "text": "Piekļuve šai sarunai vairs nav spēkā."
            },
            "not_found": {
                "title": "Saite nedarbojas",
                "text": "Adresē varētu būt kļūda, vai arī saite vairs nav derīga."
            },
            "rate_limited": {
                "title": "Pārāk daudz mēģinājumu",
                "text": "Uzgaidiet minūti, pirms mēģināt vēlreiz."
            },
            "generic": {
                "title": "Pašlaik sākt nevar",
                "text": "Mūsu pusē kaut kas nogāja greizi."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Materiāls ir slēgts",
                "text": "Šis materiāls vairs nav pieejams treniņam."
            },
            "publication_draft": {
                "title": "Materiāls vēl nav publicēts",
                "text": "Treniņš šim materiālam vēl nav atvērts."
            },
            "publication_expired": {
                "title": "Materiāla derīguma termiņš beidzies",
                "text": "Laiks, kad ar šo materiālu varēja trenēties, ir beidzies."
            },
            "feature_disabled": {
                "title": "Materiāls ir slēgts",
                "text": "Treniņš no mācību sistēmas jūsu organizācijai ir izslēgts."
            },
            "connection_disabled": {
                "title": "Materiāls ir slēgts",
                "text": "Savienojums ar jūsu mācību sistēmu ir izslēgts. Sazinieties ar personu, kas piešķīra kursu."
            },
            "launch_limit_reached": {
                "title": "Limits sasniegts",
                "text": "Ar šo materiālu jau veikts maksimālais sarunu skaits."
            },
            "daily_budget_exhausted": {
                "title": "Šodienai pietiek",
                "text": "Dienā atļautais sarunu skaits ir izmantots. Mēģiniet rīt."
            },
            "attempts_exhausted": {
                "title": "Mēģinājumi beigušies",
                "text": "Izmantoti visi šim materiālam atļautie mēģinājumi."
            },
            "quota_exhausted": {
                "title": "Pašlaik sākt nevar",
                "text": "Jūsu organizācijai vairs nav pieejamu sarunu. Sazinieties ar personu, kas piešķīra kursu."
            },
            "user_limit_reached": {
                "title": "Pašlaik sākt nevar",
                "text": "Jūsu organizācijai vairs nav brīvu vietu. Sazinieties ar personu, kas piešķīra kursu."
            },
            "scenario_unavailable": {
                "title": "Materiāls nav pieejams",
                "text": "Sarunas, uz kuru balstās šis materiāls, vairs nav."
            },
            "assignment_check_unavailable": {
                "title": "Pašlaik sākt nevar",
                "text": "Neizdevās apstiprināt, ka šis materiāls ir piešķirts tieši jums. Sazinieties ar personu, kas piešķīra kursu."
            },
            "code_invalid": {
                "title": "Saite vairs nav derīga",
                "text": "Šī saite jau izmantota, vai arī tās laiks beidzies."
            },
            "channel_verification_failed": {
                "title": "Mācību sistēma neatbildēja",
                "text": "Neizdevās apstiprināt pieprasījumu jūsu mācību sistēmā."
            },
            "external_system_unavailable": {
                "title": "Mācību sistēma neatbild",
                "text": "Neizdevās pārbaudīt jūsu kursa piešķīrumu mācību sistēmā. Mēģiniet vēlreiz pēc dažām minūtēm."
            },
            "user_not_found": {
                "title": "Neizdevās jūs identificēt",
                "text": "Jums šeit konta nav, un jūsu organizācija tos automātiski neveido. Sazinieties ar personu, kas piešķīra kursu."
            },
            "user_unavailable": {
                "title": "Jūsu konts ir izslēgts",
                "text": "Sazinieties ar personu, kas piešķīra kursu."
            },
            "user_deleted": {
                "title": "Jūsu konts ir dzēsts",
                "text": "Sazinieties ar personu, kas piešķīra kursu."
            },
            "email_taken_linking_disabled": {
                "title": "Neizdevās jūs identificēt",
                "text": "Jūsu e-pasta adrese jau pieder citam kontam. Sazinieties ar personu, kas piešķīra kursu."
            },
            "service_role_not_allowed": {
                "title": "Ar šo kontu trenēties nevar",
                "text": "Administratoru konti nepiedalās treniņa sarunās. Izmantojiet savu apmācāmā kontu."
            },
            "unverified_request": {
                "title": "Neizdevās apstiprināt pieprasījumu",
                "text": "Jūsu mācību sistēma neapstiprināja, ka šī saruna sākta no jūsu konta."
            }
        },
        "manage": {
            "nav": {
                "group": "Ārējā palaišana",
                "publications": "Publikācijas",
                "connections": "LMS savienojumi"
            },
            "messages": {
                "error": "Kaut kas nogāja greizi. Mēģiniet vēlreiz.",
                "load_error": "Neizdevās ielādēt datus."
            },
            "connections": {
                "title": "Savienojumi ar mācību sistēmām",
                "subtitle": "Mācību sistēmu konti, no kuriem šī organizācija palaiž treniņus.",
                "create": "Pievienot savienojumu",
                "edit": "Rediģēt",
                "set_credentials": "Iestatīt piekļuves datus",
                "empty": "Savienojumu pagaidām nav.",
                "secret_missing": "Nav iestatīts",
                "no_expiry": "Nebeidzas",
                "headers": {
                    "account": "Konts",
                    "base_url": "Adrese",
                    "client_id": "Klienta identifikators",
                    "secret": "Noslēpums",
                    "status": "Statuss",
                    "expires_at": "Piekļuves dati beidzas",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Nav piekļuves datu",
                    "active": "Aktīvs",
                    "expired": "Piekļuves dati beigušies",
                    "disabled": "Izslēgts"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Jauns savienojums",
                    "edit_title": "Savienojums",
                    "immutable_hint": "Mācību sistēmu un kontu nevar mainīt: tie nosaka apmācāmā identitātes telpu. Cits konts ir jauns savienojums.",
                    "lms_label": "Mācību sistēma",
                    "account_key_label": "Konts",
                    "account_key_hint": "Konta identifikators mācību sistēmā.",
                    "base_url_label": "iSpring REST API adrese",
                    "base_url_hint": "Piemēram, https://api-learn.ispringlearn.ru. Tā nav jūsu uzņēmuma portāla adrese: uz to tiek nosūtīts noslēpums.",
                    "base_url_https": "Adresei jāsākas ar https://",
                    "enabled_label": "Savienojums ir ieslēgts",
                    "enabled_hint": "Savienojums netiek dzēsts — to izslēdz. Publikācijas un palaišanas paliek sarakstos, bet jaunas palaišanas tiek noraidītas un rezultāti vairs nenonāk mācību sistēmā.",
                    "credentials_optional": "Piekļuves dati nav obligāti. Bez tiem savienojums darbojas ierobežotajā režīmā.",
                    "client_id_label": "Klienta identifikators",
                    "secret_label": "Noslēpums",
                    "secret_hint": "Tiek glabāts šifrētā veidā. To vairs nevar nolasīt — redzami tikai pēdējie četri simboli.",
                    "expires_at_label": "Piekļuves dati beidzas",
                    "expires_at_hint": "Atstājiet tukšu, ja piekļuves datiem nav derīguma termiņa."
                },
                "credentials_dialog": {
                    "title": "Piekļuves dati",
                    "lead": "Jaunais noslēpums aizstāj iepriekšējo. Savienojums saglabā savu identifikatoru, un apmācāmo saites un palaišanas paliek savās vietās.",
                    "secret_hint": "Iepriekšējais noslēpums nav vajadzīgs, un to vairs nevar nolasīt."
                },
                "messages": {
                    "saved": "Savienojums saglabāts",
                    "credentials_saved": "Piekļuves dati saglabāti"
                }
            },
            "publications": {
                "title": "Publikācijas",
                "subtitle": "Scenāriji, kas atvērti palaišanai no mācību sistēmas.",
                "create": "Jauna publikācija",
                "edit": "Rediģēt",
                "enable": "Ieslēgt",
                "disable": "Izslēgt",
                "open_journal": "Žurnāls",
                "download_package": "Lejupielādēt pakotni",
                "empty": "Publikāciju pagaidām nav.",
                "no_connections": "Savienojuma ar mācību sistēmu vēl nav. To izveido platformas administrators.",
                "no_expiry": "Bez termiņa",
                "attempts_unlimited": "Bez ierobežojuma",
                "immutable_hint": "Savienojumu, scenāriju un piegādes kanālu nevar mainīt: tie ir iestrādāti pakotnē, kas jau augšupielādēta mācību sistēmā. Viss pārējais tiek piemērots bez tās pārbūves.",
                "headers": {
                    "scenario": "Scenārijs",
                    "connection": "Savienojums",
                    "channel": "Kanāls",
                    "status": "Statuss",
                    "settings": "Iestatījumi",
                    "expires_at": "Beidzas",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Mēģinājumi: {value}",
                    "threshold": "Slieksnis: {value}"
                },
                "status": {
                    "draft": "Melnraksts",
                    "active": "Aktīva",
                    "disabled": "Izslēgta"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Tikai statuss",
                    "status_and_score": "Statuss un rezultāts",
                    "status_score_and_review": "Statuss, rezultāts un saite uz pārskatu"
                },
                "warnings": {
                    "limited_mode": "Ierobežotais režīms: rezultāts un iznākums mācību sistēmā neparādīsies, un piešķīruma pārbaude netiek veikta.",
                    "connection_disabled": "Savienojums ir izslēgts: palaišanas caur šo publikāciju vispār netiek pieņemtas, kamēr administrators savienojumu atkal neieslēdz.",
                    "assignment_check_off": "Kad slēdzis ir izslēgts, kursa pārpiešķiršana netiek atklāta.",
                    "no_course_binding": "Publikācija nav saistīta ar kursu — rezultāts mācību sistēmā nenonāks."
                },
                "dialog": {
                    "connection_label": "Savienojums",
                    "scenario_label": "Scenārijs",
                    "channel_label": "Piegādes kanāls",
                    "channel_hint": "Iestrādāts pakotnē un pēc tam nemaināms.",
                    "status_label": "Statuss",
                    "status_hint": "Publikācija netiek dzēsta — to izslēdz. Pēc tam jaunas palaišanas tiek noraidītas un vēl nenosūtītie rezultāti tiek atcelti.",
                    "settings_section": "Mēģinājuma iestatījumi",
                    "attempts_label": "Mēģinājumi uz vienu apmācāmo",
                    "attempts_unlimited": "Bez ierobežojuma",
                    "daily_budget_label": "Palaišanas dienā uz vienu apmācāmo",
                    "daily_budget_hint": "Aizsargā kvotu: katra sāktā saruna to samazina un netiek atgriezta.",
                    "result_mode_label": "Kas nonāk mācību sistēmā",
                    "pass_threshold_label": "Nokārtošanas slieksnis, 0–100",
                    "result_wait_label": "Gaidīt novērtējumu, stundas",
                    "result_wait_hint": "Pēc tam palaišana paziņos „rezultāta nav”.",
                    "launch_limit_label": "Kopējais palaišanu limits",
                    "launch_limit_hint": "Atstājiet tukšu, ja limita nav.",
                    "assignment_check_label": "Pārbaudīt piešķīrumu mācību sistēmā",
                    "binding_section": "Piesaiste mācību sistēmā",
                    "external_course_label": "Kursa ID",
                    "external_item_label": "Elementa ID",
                    "expires_label": "Publikācijas derīguma termiņš",
                    "expires_hint": "Atstājiet tukšu, ja publikācijai nav derīguma termiņa."
                },
                "key_dialog": {
                    "title": "Publikācija ir izveidota",
                    "warning": "Atslēga tiek parādīta vienu reizi un tikai šeit. To vēlāk nekur nevar nolasīt — nokopējiet to tagad un ievietojiet pakotnes iestatījumos. Ja to pazaudēsiet, būs jāizveido jauna publikācija.",
                    "key_label": "Publikācijas atslēga",
                    "copied": "Nokopēts",
                    "package_hint": "Atslēga jau ir pakotnes iekšpusē, tāpēc nekur nekas nav jāievieto. Lejupielādējiet pakotni un augšupielādējiet to mācību sistēmā. Pakotni var lejupielādēt atkārtoti jebkurā brīdī lapā Publikācijas."
                },
                "messages": {
                    "saved": "Publikācija saglabāta",
                    "enabled": "Publikācija ieslēgta",
                    "disabled": "Publikācija izslēgta",
                    "download_failed": "Neizdevās lejupielādēt pakotni. Atsvaidziniet lapu un mēģiniet vēlreiz."
                }
            },
            "journal": {
                "title": "Palaišanu žurnāls",
                "unknown_scenario": "Scenārijs nav pieejams",
                "back": "Uz publikācijām",
                "revoke": "Atsaukt mēģinājumu",
                "revoke_confirm": "Atsaukt šo mēģinājumu? Apmācāmais zaudēs piekļuvi sarunai, un nenosūtītās piegādes tiks atceltas.",
                "retry_delivery": "Atkārtot",
                "empty_launches": "Palaišanu pagaidām nav.",
                "empty_events": "Notikumu pagaidām nav.",
                "no_deliveries": "Šim mēģinājumam piegāžu nav.",
                "not_held_quota_charged": "Nenotika, kvota norakstīta",
                "relaunches": "atgriešanās: {value}",
                "last_launch": "pēdējā palaišana: {value}",
                "result_deadline": "Gaidām novērtējumu līdz {value}",
                "learner_contacts": "Mācību sistēmas nosūtītā adrese: {email}. Palaists no adreses: {ip}",
                "score_passed": "{value} — nokārtots",
                "score_failed": "{value} — nav nokārtots",
                "tabs": {
                    "launches": "Mēģinājumi",
                    "events": "Notikumi"
                },
                "headers": {
                    "learner": "Apmācāmais",
                    "user": "Konts",
                    "attempt": "Mēģinājums",
                    "status": "Statuss",
                    "game": "Saruna",
                    "started_at": "Sākts",
                    "actions": " ",
                    "event_type": "Notikums",
                    "refusal": "Iemesls",
                    "request_proof": "Pieprasījuma pierādījums",
                    "ip": "Adrese",
                    "user_agent": "Klients",
                    "happened_at": "Kad"
                },
                "launch_status": {
                    "created": "Saite izsniegta",
                    "started": "Notiek",
                    "not_held": "Nenotika",
                    "awaiting_result": "Gaidām novērtējumu",
                    "result_ready": "Rezultāts nogādāts",
                    "evaluation_failed": "Novērtējuma nav",
                    "result_timed_out": "Gaidīšanas laiks beidzies",
                    "assignment_changed": "Piešķīrums mainījies",
                    "revoked": "Atsaukts"
                },
                "delivery": {
                    "version": "Versija",
                    "status": "Statuss",
                    "outcome": "Iznākums",
                    "result": "Rezultāts",
                    "score": "Punkti",
                    "attempts": "Mēģinājumi",
                    "last_attempt": "Pēdējais mēģinājums",
                    "external_state": "Stāvoklis mācību sistēmā"
                },
                "delivery_status": {
                    "pending": "Rindā",
                    "in_progress": "Tiek nosūtīts",
                    "done": "Pabeigts",
                    "needs_attention": "Nepieciešama uzmanība"
                },
                "delivery_outcome": {
                    "accepted": "Pieņemts",
                    "confirmed": "Apstiprināts",
                    "rejected_by_external": "Noraidīts",
                    "retry": "Ieplānots atkārtojums",
                    "cancelled": "Atcelts",
                    "assignment_changed": "Piešķīrums mainījies"
                },
                "result": {
                    "passed": "Nokārtots",
                    "failed": "Nav nokārtots",
                    "not_held": "Nenotika",
                    "no_result": "Rezultāta nav"
                },
                "refusal": {
                    "publication_disabled": "Publikācija izslēgta",
                    "publication_draft": "Publikācija ir melnraksts",
                    "publication_expired": "Publikācijas termiņš beidzies",
                    "feature_disabled": "Ārējā palaišana izslēgta",
                    "connection_disabled": "Savienojums izslēgts",
                    "launch_limit_reached": "Sasniegts palaišanu limits",
                    "daily_budget_exhausted": "Dienas budžets izsmelts",
                    "attempts_exhausted": "Mēģinājumi izsmelti",
                    "quota_exhausted": "Organizācijas kvota izsmelta",
                    "user_limit_reached": "Brīvu vietu nav",
                    "scenario_unavailable": "Scenārijs nav pieejams",
                    "assignment_check_unavailable": "Piešķīruma pārbaude nav pieejama",
                    "code_invalid": "Saite izmantota vai beigusies",
                    "channel_verification_failed": "Mācību sistēma neapstiprināja pieprasījumu",
                    "external_system_unavailable": "Mācību sistēma neatbildēja uz piešķīruma pārbaudi",
                    "user_not_found": "Apmācāmajam nav konta",
                    "user_unavailable": "Apmācāmā konts izslēgts",
                    "user_deleted": "Apmācāmā konts dzēsts",
                    "email_taken_linking_disabled": "Adrese pieder citam kontam",
                    "service_role_not_allowed": "Servisa konts nevar trenēties",
                    "unverified_request": "Pieprasījums nav apstiprināts"
                },
                "event_type": {
                    "launch_refused": "Palaišana noraidīta",
                    "exchange_refused": "Saite noraidīta",
                    "exchange_succeeded": "Saite izmantota"
                },
                "request_proof": {
                    "unverified": "Nav apstiprināts",
                    "assignment_verified": "Piešķīrums apstiprināts"
                },
                "messages": {
                    "retry_queued": "Atkārtojums ievietots rindā",
                    "revoked": "Mēģinājums atsaukts"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Treniņš",
            "interview": "Intervija"
        },
        "load": {
            "loading": "Ielādē sesiju…",
            "failed": "Neizdevās ielādēt sesiju. Pārbaudiet savienojumu un mēģiniet vēlreiz.",
            "scenarioFailed": "Scenārijs netika ielādēts",
            "scenarioRetry": "Mēģināt vēlreiz"
        },
        "leave": {
            "confirm": "Saruna vēl turpinās. Aiziešana no lapas to nepārtrauks, un laiks turpinās skaitīties. Vai pamest lapu?",
            "confirmEnd": "Saruna vēl turpinās. Ja aiziesiet, tā beigsies un tiks novērtēta pēc tā, ko paspējāt aptvert. Vai aiziet?"
        },
        "elsewhere": {
            "interviewTitle": "Intervija ir atvērta citā cilnē",
            "interviewText": "Intervija turpinās citā cilnē vai citā ierīcē. Turpiniet to tur — šo cilni varat aizvērt.",
            "conversationTitle": "Saruna ir atvērta citā cilnē",
            "conversationText": "Saruna turpinās citā cilnē vai citā ierīcē. Turpiniet to tur — šo cilni varat aizvērt."
        },
        "prep": {
            "header": {
                "backToSessions": "Uz sesijām",
                "themeToggleAriaLabel": "Pārslēgt tēmu"
            },
            "scenario": {
                "sectionLabel": "Scenārijs",
                "competenceLabel": "Vērtējamā kompetence",
                "gameNumber": "Sesija #{number}",
                "duration": "{minutes} min",
                "readFull": "Lasīt pilnībā",
                "generalLabel": "Vispārīga informācija",
                "playerLabel": "Informācija jums"
            },
            "selfCamera": {
                "previewLabel": "Jūsu kameras priekšskatījums",
                "off": "Kamera ir izslēgta"
            },
            "notes": {
                "empty": "Tukšs"
            },
            "start": {
                "button": "Sākt sesiju",
                "interviewButton": "Sākt interviju",
                "resumeButton": "Atgriezties sarunā",
                "resumeHint": "Saruna jau notiek — laiks turpina skaitīties."
            }
        },
        "equipment": {
            "status": {
                "checking": "Pārbauda ierīces",
                "waiting": "Gaida atļauju",
                "denied": "Piekļuve liegta",
                "busy": "Ierīce aizņemta",
                "noCamera": "Nav kameras",
                "missing": "Nav mikrofona",
                "dismissed": "Piekļuve nav piešķirta",
                "ready": "Ierīces gatavas"
            },
            "checking": {
                "title": "Pārbauda jūsu mikrofonu un kameru…"
            },
            "waiting": {
                "title": "Atļaujiet piekļuvi mikrofonam",
                "cameraTitle": "Atļaujiet piekļuvi kamerai",
                "description": "Pārlūkprogrammas atļaujas pieprasījums jau ir atvērts. Bez mikrofona sarunu nevar sākt."
            },
            "denied": {
                "title": "Pārlūkprogramma bloķē mikrofonu",
                "cameraTitle": "Pārlūkprogramma bloķē kameru",
                "description": "Pārlūkprogramma iegaumēja bloķēšanu. Atļaujiet piekļuvi mikrofonam vietnes iestatījumos un atsvaidziniet lapu.",
                "cameraDescription": "Pārlūkprogramma iegaumēja bloķēšanu. Atļaujiet piekļuvi kamerai vietnes iestatījumos un atsvaidziniet lapu.",
                "showInstructions": "Parādīt, kā",
                "hideInstructions": "Slēpt",
                "chromeEdge": {
                    "browser": "Chrome un Edge",
                    "text": "Noklikšķiniet uz slēdzenes ikonas pa kreisi no adreses joslas, atveriet \"Vietnes iestatījumi\", atļaujiet \"Mikrofons\" un atsvaidziniet lapu."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Atveriet Safari izvēlni → \"Šīs vietnes iestatījumi\", atļaujiet \"Mikrofons\" un atsvaidziniet lapu."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Noklikšķiniet uz mikrofona ikonas adreses joslā, noņemiet bloķēšanu šai vietnei un atsvaidziniet lapu."
                },
                "system": {
                    "title": "Jūsu sistēma liedz pārlūkprogrammai piekļuvi mikrofonam",
                    "cameraTitle": "Jūsu sistēma liedz pārlūkprogrammai piekļuvi kamerai",
                    "macos": "macOS: Sistēmas iestatījumi → Konfidencialitāte un drošība → Mikrofons (vai Kamera) → ieslēdziet savu pārlūkprogrammu un pēc tam to pārstartējiet.",
                    "windows": "Windows: Iestatījumi → Konfidencialitāte un drošība → Mikrofons (vai Kamera) → atļaujiet piekļuvi lietotnēm un savai pārlūkprogrammai, tad nospiediet \"Mēģināt vēlreiz\"."
                }
            },
            "busy": {
                "title": "Mikrofonu izmanto cita lietotne",
                "cameraTitle": "Kameru izmanto cita lietotne",
                "description": "Parasti tas ir zvans, kas palicis darboties fonā. Aizveriet to un nospiediet \"Mēģināt vēlreiz\".",
                "retry": "Mēģināt vēlreiz"
            },
            "noCamera": {
                "title": "Nav kameras",
                "description": "Jūs būs dzirdams, bet ne redzams.",
                "requiredByScenario": "Šai sarunai nepieciešama kamera. Pievienojiet to, lai turpinātu."
            },
            "missing": {
                "title": "Mikrofons nav atrasts",
                "description": "Pievienojiet mikrofonu un nospiediet \"Mēģināt vēlreiz\". Bez tā saruna nevar sākties."
            },
            "dismissed": {
                "title": "Piekļuve mikrofonam netika piešķirta",
                "cameraTitle": "Piekļuve kamerai netika piešķirta",
                "description": "Pārlūkprogrammas logs tika aizvērts bez atbildes. Nospiediet \"Mēģināt vēlreiz\" un atļaujiet piekļuvi."
            },
            "ready": {
                "title": "Ierīces gatavas"
            },
            "micLabel": "Mikrofons",
            "cameraLabel": "Kamera",
            "chooseMic": "Izvēlēties mikrofonu",
            "chooseCamera": "Izvēlēties kameru",
            "micLevelHint": "Sakiet kaut ko",
            "speakerValue": "Skaļrunis: {name}",
            "configure": "Iestatīt",
            "dialog": {
                "title": "Ierīces",
                "lockedDuringConversation": "Sarunas laikā ierīces nevar mainīt.",
                "micSelectLabel": "Mikrofons",
                "cameraSelectLabel": "Kamera",
                "speakerSelectLabel": "Skaļrunis",
                "noCameraOption": "Bez kameras",
                "record": "Ierakstīt 3 sekundes",
                "recording": "Ieraksta…",
                "recordFailed": "Neizdevās ierakstīt. Mēģiniet vēlreiz.",
                "listen": "Noklausīties",
                "playing": "Atskaņo…",
                "done": "Pabeigts",
                "closeAriaLabel": "Aizvērt dialogu"
            },
            "unnamed": {
                "microphone": "Mikrofons {number}",
                "camera": "Kamera {number}",
                "speaker": "Skaļrunis {number}"
            },
            "cameraWarmup": {
                "preview": "Kamera ieslēdzas",
                "title": "Mikrofons ir gatavs",
                "description": "Kamera drīz ieslēgsies — parasti vienas vai divu sekunžu laikā.",
                "slowHint": "Kamera neieslēdzas? Izvēlieties citu, nospiežot «Iestatīt»."
            }
        },
        "recording": {
            "videoAndAudio": "Saruna un video tiek ierakstīti.",
            "audioOnly": "Saruna tiek ierakstīta.",
            "accessSelfAndEvaluators": "Ieraksts ir pieejams Jums un tiem, kas vērtē Jūsu darbu.",
            "accessEvaluators": "Ieraksts ir pieejams tiem, kas vērtē Jūsu darbu."
        },
        "scenario": {
            "video": "Scenārija autora video"
        },
        "notes": {
            "title": "Sesijas piezīmes",
            "placeholder": "Ko vēlaties trenēt, kādas frāzes esat sagatavojis(-usi)",
            "saving": "Saglabājam…",
            "saved": "Saglabāts",
            "saveError": "Neizdevās saglabāt",
            "visibility": "Piezīmes ir redzamas Jums un tiem, kas vērtē sesiju.",
            "unsupported": "Šajās piezīmēs ir elementi, kurus šeit nevar rediģēt. Tie ir saglabāti nemainīti."
        },
        "stage": {
            "agentState": {
                "speaking": "Runā",
                "listening": "Klausās",
                "thinking": "Domā"
            },
            "micOffWarning": "Mikrofons ir izslēgts — sarunu biedrs Jūs nedzird",
            "micOnAriaLabel": "Izslēgt mikrofonu",
            "micOffAriaLabel": "Ieslēgt mikrofonu",
            "micOff": "Mikrofons izslēgts",
            "micOnAnnouncement": "Mikrofons ieslēgts",
            "captionsLabel": "Subtitri",
            "captionsOnAriaLabel": "Slēpt subtitrus",
            "captionsOffAriaLabel": "Rādīt subtitrus",
            "talkBalance": {
                "title": "Runas līdzsvars",
                "you": "Jūs",
                "interlocutor": "Sarunu biedrs"
            },
            "connectionQuality": {
                "excellent": "Izcils savienojums",
                "good": "Labs savienojums",
                "poor": "Vājš savienojums",
                "unknown": "Savienojuma kvalitāte nav zināma"
            },
            "selfCameraLabel": "Jūs",
            "timeWarning": {
                "lastMinute": "Atlikusi viena minūte — laiks noslēgt",
                "finalSeconds": "15 sekundes — pabeidziet savu domu"
            },
            "timeUp": {
                "title": "Laiks beidzies",
                "text": "Saruna aizvērsies pati, to nevar pagarināt.",
                "closing": "Aizveram sarunu…"
            },
            "voiceOnly": "Balss režīms — šim scenārijam nav video",
            "interlocutorConnecting": {
                "title": "Sarunu biedrs pieslēdzas",
                "hint": "Parasti 2–4 sekundes"
            },
            "layout": {
                "label": "Blakus",
                "sideTitle": "Novietot blakus",
                "focusTitle": "Palielināt sarunu biedru"
            }
        },
        "panels": {
            "scenario": "Scenārijs",
            "transcript": "Transkripcija",
            "transcriptEmpty": "Šeit parādīsies pabeigtās replikas.",
            "notes": "Piezīmes",
            "characterMemoryTab": "Ko atceras personāžs",
            "openAriaLabel": "Atvērt paneli \"{panel}\"",
            "closeAriaLabel": "Aizvērt paneli \"{panel}\""
        },
        "sound": {
            "label": "Skaņa",
            "volumeLabel": "Skaļums",
            "speakerLabel": "Skaļrunis"
        },
        "end": {
            "button": "Beigt",
            "confirmTitle": "Vai beigt sarunu?",
            "elapsed": "Pagājis {elapsed} no {total}.",
            "partialEvaluationNotice": "Saruna tiks novērtēta pēc tā, ko paspējāt aptvert.",
            "continue": "Turpināt",
            "notSent": "Saruna beigsies pēc laika: serveris neatbildēja uz beigšanas pieprasījumu."
        },
        "wait": {
            "title": "Gatavojam sarunu",
            "hint": "Parasti tas aizņem 1–3 minūtes. Neaizveriet lapu — sāksim automātiski.",
            "nextTry": "Nākamais mēģinājums pēc {time}",
            "trying": "Mēģinām sākt…",
            "retrying": "Pagaidām neizdevās. Mēģināsim vēlreiz pēc {time}",
            "cancel": "Atcelt",
            "failed": {
                "title": "Neizdevās sākt sarunu",
                "text": "Pašlaik nav brīvu vietu. Mikrofona un kameras iestatījumi ir saglabāti — mēģiniet vēlreiz pēc pāris minūtēm.",
                "retry": "Mēģināt vēlreiz"
            }
        },
        "connection": {
            "reconnecting": "Savienojums zaudēts, atkārtoti savienojamies…",
            "restored": "Savienojums atjaunots",
            "failed": "Neizdevās atjaunot savienojumu",
            "retry": "Mēģināt vēlreiz"
        },
        "hotkeys": {
            "title": "Tastatūras īsinājumtaustiņi",
            "showHintAriaLabel": "Rādīt tastatūras īsinājumtaustiņus",
            "micToggle": "Ieslēgt/izslēgt mikrofonu",
            "scenarioPanel": "Scenārijs: atvērt un aizvērt paneli",
            "transcriptPanel": "Transkripcija",
            "notesPanel": "Piezīmes",
            "captionsToggle": "Ieslēgt/izslēgt subtitrus",
            "closeTopLayer": "Aizvērt paneli, uznirstošo logu vai dialogu",
            "endConfirm": "Beigt — atver apstiprinājumu",
            "showHint": "Rādīt šo padomu"
        },
        "intro": {
            "candidate": {
                "greeting": "Labdien, {name}!",
                "leadWithVacancy": "{organization} aicina Jūs uz interviju ar virtuālo sarunu biedru vakancei «{vacancy}».",
                "duration": "Intervija ilgs apmēram {minutes} min.",
                "requirementsTitle": "Kas nepieciešams",
                "requirementMic": "Strādājošs mikrofons, ieteicams — austiņas ar mikrofonu",
                "requirementCameraRequired": "Ieslēgta kamera: šai intervijai tā ir obligāta",
                "requirementCameraOptional": "Kamera nav obligāta, bet ar to saruna norit dabiskāk",
                "requirementBrowser": "Dators ar jaunāko Chrome, Edge vai Safari versiju",
                "requirementNetwork": "Stabils interneta pieslēgums un klusa vieta, kur neviens Jūs netraucēs",
                "consentTextLabel": "Piekrišanas teksts",
                "consentAccept": "Esmu iepazinies(-usies) ar tekstu un piekrītu savu personas datu apstrādei",
                "next": "Tālāk"
            },
            "launch": {
                "title": "Treniņa saruna",
                "lead": "Tagad jūs sarunāsieties ar virtuālu sarunu biedru. Saruna tiek ierakstīta un novērtēta, un rezultāts nonāks jūsu mācību sistēmā.",
                "requirementsTitle": "Kas jums būs nepieciešams",
                "requirementMic": "Funkcionējošs mikrofons, vēlams austiņas ar mikrofonu",
                "requirementCamera": "Kamera nav obligāta, taču ar to saruna kļūst dzīvāka",
                "requirementBrowser": "Dators ar aktuālu Chrome, Edge vai Safari versiju",
                "requirementNetwork": "Stabils savienojums un klusa vieta, kur jūs netraucēs",
                "start": "Sākt"
            }
        },
        "finished": {
            "candidate": {
                "title": "Paldies!",
                "text": "Intervija ir pabeigta. Rezultāts nonāks pie rekrutiera, kurš sazināsies ar Jums. Šo lapu tagad var aizvērt."
            },
            "launch": {
                "title": "Paldies!",
                "text": "Saruna ir pabeigta. Rezultāts parādīsies jūsu mācību sistēmā, tiklīdz būs gatavs novērtējums. Šo lapu tagad varat aizvērt."
            }
        },
        "closeDialogAriaLabel": "Aizvērt dialogu"
    },
    "loopAvatars": {
        "title": "Cikliskie avatāri",
        "upload": "Augšupielādēt avatāru",
        "newVersion": "Jauna versija",
        "newVersionHint": "“{name}”, pašreizējā versija {version}. Jaunā pakotne aizstās video visos profilos ar šo avatāru.",
        "edit": "Rediģēt avatāru",
        "delete": "Dzēst avatāru",
        "empty": "Avatāru vēl nav",
        "headers": {
            "poster": "Plakāts",
            "name": "Nosaukums",
            "gender": "Dzimums",
            "emotion": "Emocija",
            "visibility": "Redzamība",
            "version": "Versija",
            "profiles": "Profili"
        },
        "gender": {
            "male": "Vīrietis",
            "female": "Sieviete"
        },
        "emotion": {
            "calm": "Mierīgs",
            "friendly": "Draudzīgs",
            "strict": "Stingrs"
        },
        "visibility": {
            "all": "Visas organizācijas"
        },
        "fields": {
            "package": "Avatāra pakotne (.zip)"
        },
        "packageHint": "ZIP līdz 100 MB ar manifest.json, listen.mp4, talk.mp4, transitions.json un poster.jpg",
        "validation": {
            "packageTooLarge": "Pakotne nedrīkst pārsniegt 100 MB"
        },
        "errors": {
            "requestFailed": "Pieprasījums neizdevās. Mēģiniet vēlreiz."
        },
        "confirmDetach": "Atvienojamie profili: {count}. Tie pārslēgsies uz fotoattēlu. Saglabāt?",
        "confirmDelete": "Dzēst avatāru “{name}”?",
        "confirmDeleteWithProfiles": "Avatārs “{name}” tiek izmantots profilos: {count}. Tie pārslēgsies uz fotoattēlu. Dzēst?"
    },
    "ttsVoices": {
        "title": "TTS balsis",
        "create": "Pievienot balsi",
        "edit": "Rediģēt balsi",
        "delete": "Dzēst balsi",
        "replaceSample": "Aizstāt paraugu",
        "replaceSampleHint": "“{name}”, pašreizējā parauga versija {version}. Jaunais paraugs skanēs visos profilos ar šo balsi.",
        "empty": "Balsu vēl nav",
        "play": "Noklausīties paraugu",
        "stop": "Apturēt",
        "headers": {
            "name": "Nosaukums",
            "provider": "Pakalpojumu sniedzējs",
            "externalId": "Balss ID",
            "gender": "Dzimums",
            "languages": "Valodas",
            "visibility": "Redzamība",
            "sample": "Paraugs",
            "profiles": "Profili"
        },
        "gender": {
            "male": "Vīrietis",
            "female": "Sieviete"
        },
        "visibility": {
            "all": "Visas organizācijas"
        },
        "fields": {
            "sample": "Balss paraugs",
            "speed": "Runas ātrums"
        },
        "sampleHint": "MP3, MP4 vai M4A līdz 5 MB",
        "sampleOptionalHint": "Pēc izvēles — paraugs tiks ģenerēts ar balsi pēc tās ID. MP3, MP4 vai M4A līdz 5 MB",
        "synthesizeSample": "Ģenerēt vēlreiz",
        "speedChangedHint": "Lai dzirdētu jauno ātrumu, ģenerējiet balss paraugu vēlreiz.",
        "speedSamplePromptTitle": "Ātrums mainīts",
        "speedSamplePrompt": "Paraugs joprojām skan ar iepriekšējo ātrumu. Vai ģenerēt to vēlreiz? Pašreizējais paraugs tiks aizstāts.",
        "saveAndSynthesize": "Saglabāt un ģenerēt",
        "saveOnly": "Tikai saglabāt",
        "validation": {
            "sampleTooLarge": "Paraugs nedrīkst pārsniegt 5 MB"
        },
        "errors": {
            "requestFailed": "Pieprasījums neizdevās. Mēģiniet vēlreiz.",
            "sampleUnavailable": "Paraugu neizdevās atskaņot"
        },
        "confirmDetach": "Atvienojamie profili: {count}. Tie pārslēgsies uz savienojuma balsi. Saglabāt?",
        "confirmDelete": "Dzēst balsi “{name}”?",
        "confirmDeleteWithProfiles": "Balss “{name}” tiek izmantota profilos: {count}. Tie pārslēgsies uz savienojuma balsi. Dzēst?",
        "picker": {
            "none": "Noklusējuma balss",
            "empty": "Katalogā nav šī dzimuma balsu",
            "loadError": "Neizdevās ielādēt balsis",
            "playSample": "Noklausīties paraugu: {name}",
            "stopSample": "Apturēt paraugu: {name}",
            "sampleUnavailable": "Paraugs nav pieejams"
        }
    },
    "realtimeAvatars": {
        "title": "Live avatāri",
        "create": "Pievienot avatāru",
        "edit": "Rediģēt avatāru",
        "delete": "Dzēst avatāru",
        "preview": "Skatīt priekšskatījumu",
        "empty": "Avatāru vēl nav",
        "headers": {
            "poster": "Plakāts",
            "name": "Nosaukums",
            "provider": "Pakalpojumu sniedzējs",
            "externalId": "Avatāra ID",
            "gender": "Dzimums",
            "visibility": "Redzamība",
            "profiles": "Profili",
            "models": "Anam modeļi"
        },
        "gender": {
            "male": "Vīrietis",
            "female": "Sieviete"
        },
        "visibility": {
            "all": "Visas organizācijas"
        },
        "nameHint": "Neobligāti — tiks izmantots nosaukums no Anam",
        "externalIdHint": "Mainot ID, plakāts un priekšskatījums tiks ielādēts no Anam vēlreiz",
        "errors": {
            "requestFailed": "Pieprasījums neizdevās. Lūdzu, mēģiniet vēlreiz.",
            "previewUnavailable": "Priekšskatījumu neizdevās atskaņot"
        },
        "confirmDetach": "Atsaistāmie profili: {count}. Tie pārslēgsies uz fotoattēlu. Saglabāt?",
        "confirmDelete": "Dzēst avatāru “{name}”?",
        "confirmDeleteWithProfiles": "Avatārs “{name}” tiek izmantots profilos: {count}. Tie pārslēgsies uz fotoattēlu. Dzēst?",
        "picker": {
            "label": "Live avatāri",
            "empty": "Šim profilam nav pieejamu Live avatāru",
            "emptyFiltered": "Nav Live avatāru ar šādu dzimumu",
            "loadError": "Neizdevās ielādēt Live avatārus"
        }
    },
    "aiProfileAppearance": {
        "label": "Izskats",
        "photo": "Savs fotoattēls",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Maskots",
        "filterGender": "Dzimums",
        "filterEmotion": "Emocija",
        "avatarsLabel": "Avatāri",
        "avatarRequired": "Izvēlieties avatāru",
        "liveRequired": "Izvēlieties Live avatāru",
        "livePlaceholder": "Šeit parādīsies jūsu Live avatārs",
        "empty": "Šim profilam nav pieejamu avatāru",
        "emptyFiltered": "Neviens avatārs neatbilst filtriem",
        "loadError": "Neizdevās ielādēt avatārus",
        "playPreview": "Atskaņot priekšskatījumu: {name}",
        "pausePreview": "Pauzēt priekšskatījumu: {name}"
    },
  "emailStopList": {
    "title": "E-pasta stopsaraksts",
    "description": "Uz šīm adresēm un domēniem vēstules netiek sūtītas. Domēna ieraksts attiecas uz visām šī domēna adresēm, bet ne uz tā apakšdomēniem.",
    "searchPlaceholder": "Meklēt pēc adreses vai domēna",
    "allReasons": "Visi iemesli",
    "add": "Pievienot",
    "addTitle": "Bloķēt adresi vai domēnu",
    "empty": "Stopsaraksts ir tukšs",
    "editNote": "Rediģēt piezīmi",
    "headers": {
      "type": "Veids",
      "value": "Adrese vai domēns",
      "reason": "Iemesls",
      "providerReply": "E-pasta servisa atbilde",
      "note": "Piezīme",
      "author": "Pievienoja",
      "createdAt": "Pievienošanas datums",
      "blockedCount": "Apturēto vēstuļu skaits",
      "lastBlockedAt": "Pēdējoreiz apturēta"
    },
    "type": {
      "address": "Adrese",
      "domain": "Domēns"
    },
    "reason": {
      "manual": "Pievienota manuāli",
      "providerRejected": "E-pasta serviss noraidīja"
    },
    "author": {
      "system": "Sistēma"
    },
    "fields": {
      "value": "Adrese vai domēns",
      "valueHint": "Norādiet pilnu adresi vai tikai domēnu. Domēns bloķē visas tā adreses, bet ne apakšdomēnus.",
      "note": "Piezīme"
    },
    "errors": {
      "requestFailed": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz."
    },
    "unblock": {
      "action": "Atbloķēt",
      "confirm": "Atbloķēt {value}?",
      "resultTitle": "Atbloķēšanas rezultāts",
      "result": {
        "removedEverywhere": "Atbloķēts. E-pasta servisa stopsarakstā šīs adreses nav, tāpēc vēstules atkal tiks sūtītas.",
        "removedLocally": "Domēns atbloķēts. Šī domēna adreses, kurām ir savs ieraksts, paliek bloķētas.",
        "providerNotConfigured": "Noņemts tikai platformas ieraksts: savienojums ar e-pasta servisu nav iestatīts, tāpēc tā stopsaraksts netika pārbaudīts.",
        "providerUnavailable": "E-pasta serviss nav pieejams, mēģiniet vēlāk. Adrese joprojām ir bloķēta.",
        "stillListedAtProvider": "Adrese ir e-pasta servisa stopsarakstā. Noņemiet to servisa panelī un nospiediet „Atbloķēt vēlreiz“. Ja panelī adreses nav, tā ir servisa globālajā stopsarakstā, un no turienes to noņemt nevar."
      },
      "openPanel": "Atvērt e-pasta servisa paneli",
      "panelPath": "Kur noņemt: e-pasta servisa panelis → Products → Email Service → jūsu resurss → cilne Stop Lists.",
      "retry": "Atbloķēt vēlreiz"
    },
    "suggestions": {
      "text": "Domēnā {domain} bloķēto adrešu skaits: {count}. Bloķēt visu domēnu?",
      "block": "Bloķēt domēnu",
      "confirm": "Bloķēt domēnu {domain}? Vēstules uz visām tā adresēm vairs netiks sūtītas. Apakšdomēnus tas neskars, atsevišķu adrešu ieraksti paliks."
    },
    "check": {
      "title": "Pārbaudīt adresi",
      "hint": "Parādīs, vai vēstules uz adresi bloķē platforma vai e-pasta serviss",
      "placeholder": "E-pasta adrese",
      "submit": "Pārbaudīt",
      "resultFor": "Rezultāts adresei {email}",
      "platform": "Platformas stopsaraksts",
      "platformListed": "Jā — ieraksts „{value}“",
      "provider": "E-pasta servisa stopsaraksts",
      "listed": "Jā",
      "notListed": "Nē",
      "providerReasons": "E-pasta servisa norādītie iemesli:",
      "providerNotConfigured": "Savienojums ar e-pasta servisu nav iestatīts",
      "providerUnavailable": "E-pasta serviss nav pieejams, mēģiniet vēlāk"
    }
  }
}
